import { filter, finalize } from 'rxjs/operators';
import { Component, OnInit, EventEmitter, AfterViewInit, OnChanges, ViewChildren, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ContractService } from 'src/app/core/services/contract.service';
import { ReloadEventEmitterService } from 'src/app/core/services/reload-event-emitter.service';

declare var $: any; // ADD THIS
import * as $ from 'jquery';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { Message } from 'src/app/core/class/message';
import { DatePipe } from '@angular/common';
import { MatDatepickerInputEvent, MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { AbstractControl, FormBuilder, FormControl, FormGroup, NgForm, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  EnumContractStatus,
  EnumContractUserRole,
  EnumContractEnterpriseStatus,
  EnumContractSendBCTStatus
} from 'src/app/core/constants/contract';
import { Subscription } from 'rxjs';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import AuthUtils from 'src/app/core/services/auth-utils';
import { FeatureGroup } from 'src/app/core/constants/permission';
import { CommonService } from 'src/app/core/services/common.service';
import { UserService } from 'src/app/core/services/user.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { PRIMARY_COLOR } from 'src/app/app.component';
import { DeclineSignDocumentComponent } from '../../document/decline-sign-document/decline-sign-document.component';
import { ModalMoneyTransferComponent } from './modal-money-transfer/modal-money-transfer.component';
import { EnterpriseConfigService } from 'src/app/core/services/enterprise-config.service';

declare function numberWithCommas(number): any;

interface Series {
  name: string;
  data: any[];
  yAxis: number;
  color: string;
  marker?: {};
}

@Component({
  selector: 'app-analysis-report-enterprise',
  templateUrl: './analysis-report-enterprise.component.html',
  styleUrls: ['./analysis-report-enterprise.component.scss']
})

export class AnalysisReportEnterpriseComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  constructor(
    public customerFilter: CustomerFilterLanguage,
    private contractService: ContractService,
    private reloadEventEmitterService: ReloadEventEmitterService,
    private message: Message,
    public datepipe: DatePipe,
    private toastr: ToastrService,
    private router: Router,
    private formBuilder: FormBuilder,
    private responsiveService: ResponsiveService,
    private commonService: CommonService,
    private userService: UserService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    private enterpriseConfigService: EnterpriseConfigService,
  ) {
    this.isShowWarningQuanitySMS = false;
    this.isShowWarningQuanityContract = false;
    this.isShowWarningQuanityContract1MB = false;
    this.color_primary = '#F5222D';
    this.isShowWarningQuanityEkyc = false;
    this.isShowWarningQuanityEkycAdvanced = false;
    this.isShowWarningStorageDigitalContract = false;
    this.isShowWarningExpireDigContract = false;
    this.isShowWarningExpireContract1MBQuantity = false;
    this.isShowWarningQuanityTindy = false;
    this.isShowWarningQuanityMytime = false;
    this.isShowWarningQuanityMysign = false;
    this.colorsPieCharts = ['#268AFF', '#FA5C65', '#37DC94', '#FD9A28'];
    this.colorsBCTPieCharts = ['#268AFF', '#37DC94', '#FA5C65'];


    // Mặc định là user có các quyền bình thường thì show khối: Người dùng --[0]
    this.isShowByServiceReport = false;
    this.isShowEnterpriseReport = false;
    this.isShowUserReport = true;
    this.isShowPartnerReport = false;
    this.isShowByConsumptionReport = false;

    this.permissions = localStorage.getItem('permissions').match(/\d+/g).map(Number);
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();

    if (this.isNotAttestedUser) {
      this.colorsPieCharts.splice(2, 0, '#ebff02');
    }
  }

  storageDigitalContractValue = '0';
  storageThan10MBValue = '0';
  storageDigContractExpireTitle = '';
  ContractQuantityExpireTitle = '';
  Contract1MBQuantityExpireTitle = '';
  unitStorageDigitalContract = '';
  unitStorageThan10MB = '';
  messageNotify = '';
  isShowRounding = false;
  colorsPieCharts: string[];
  colorsBCTPieCharts: string[];
  colorsColumnCharts: string[];
  // language: string;
  isShowByServiceReport: boolean;
  isShowEnterpriseReport: boolean;
  isShowUserReport: boolean;
  isShowPartnerReport: boolean;
  isShowByConsumptionReport: boolean;
  permissions: number[];
  public subscription: Subscription;
  dialogRef: any;
  visible: boolean;
  isStorageContract1mb = true;
  // check bought ekyc and ekyc advanced
  isBoughtEkyc = true;
  isBoughtEkycAdvanced = true;

  // check storage digital contract
  isStorageDigitalContract = true;
  isStorageBiggerThan10MBFileSize = true;
  biggerThan10MBFileSize: number = 0;
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;

  // feature group
  NORMAL_USER = 0; // Quản lý thông tin doanh nghiệp
  BUSSINESS_INFORMATION_MANAGEMENT = 1; // Quản lý thông tin doanh nghiệp
  MANAGE_USER_INFORMATION = 2; // Quản lý thông tin người dùng
  MANAGE_DOCUMENTS_CATOLOG = 3; // Quản lý danh mục văn bản
  CUSTOMER_INFORMATION_MANAGEMENT = 4; // Quản lý thông tin khách hàng
  DOCUMENT_CREATE_MANAGEMENT = FeatureGroup.CREATE_SIDE_DOCUMENT; // Quản lý tài liệu công ty la
  DOCUMENT_RECEIVE_MANAGEMENT = FeatureGroup.RECEIVE_SIDE_DOCUMENT; // Quản lý tài liệu nhận từ đối tác
  SIGN_THE_DOCUMENT_NUMBER = FeatureGroup.SIGN; // Ký số tài liệu

  documentEnterpriseReceive = {
    waitSetSignFlow: 0,
    processing: 0,
    rejected: 0,
    signed: 0
  };
  // Obj Doanh Nghiep
  enterprise = {
    countCreatorWaitSign: 0,
    countReceiverWaitSign: 0,
    countCreatorRejected: 0,
    countCreatorSent: 0,
    countDenied: 0,
    countFinish: 0
  };

  // Obj Doi Tac
  partner = {
    totalDocumentsWaitingForProgressing: null,
    totalDocumentsFinish: null,
    totalDocumentsDenied: null
  };

  // Obj DN Mua Dich Vu
  enterpriseByService = {
    contract_1mb_quantity: 0,
    contract_quantity: 0,
    sms_quantity: 0,
    money_quantity: 0,
    tsa_money_quantity: 0,
    cpAccountCode: '',
    ekyc_quantity: 0,
    ekyc_advanced_quantity: 0,
    storage_digital_contract: 0,
    storage_than10MB: 0,
    // Tài nguyên mới
    tindy_quantity: 0,
    mytime_quantity: 0,
    mysign_quantity: 0
  };

  // Khoi tao chart
  highcharts = Highcharts;
  chartOptionsEnterprise: any;
  showChartEnterprise = true
  chartOptionsBCT: any;
  showChartBCT = true
  chartOptionsUser: any;
  chartOptionsUserHandle: any;
  isShowImageNoDataChartColumn: boolean;
  isShowImageNoDataChartPie: boolean;
  isShowWarningQuanitySMS: boolean;
  isShowWarningQuanityContract: boolean;
  isShowWarningQuanityContract1MB: boolean;
  isShowWarningQuanityMoney: boolean;
  isShowWarningQuanityTsaMoney: boolean;

  isShowWarningQuanityEkyc: boolean;
  isShowWarningQuanityEkycAdvanced: boolean;
  isBuySmsBccs = true;
  isBuyTsaSmsBccs = true;
  isBuyContract1Mb: boolean = true;

  isShowWarningStorageDigitalContract: boolean;
  isShowWarningStorageThan10MBFileSize: boolean;

  // Tài nguyên mới
  isBoughtTindy = true;
  isBoughtMytime = true;
  isBoughtMysign = true;
  isShowWarningQuanityTindy: boolean;
  isShowWarningQuanityMytime: boolean;
  isShowWarningQuanityMysign: boolean;

  isShowWarningExpireDigContract: boolean;
  isShowWarningExpiredThan10MBFileSize: boolean;
  isShowWarningExpireContractQuantity: boolean;
  isShowWarningExpireContract1MBQuantity: boolean;
  isTransferSmsToTsa: boolean;
  isTransferTsaToSms: boolean;
  warningRemittanceSMS = 0;
  warningRemittanceTSA = 0;
  // consumption
  // maxDateConsumption = moment(new Date()).format('YYYY-MM-DD');
  defaultModelCreateTime = {
    createdTimeFrom: moment().subtract(30, 'd').format('YYYY-MM-DD'),
    createdTimeTo: moment(new Date()).format('YYYY-MM-DD')
  };
  isShowWarningConsumptionFromDate: boolean;
  isShowWarningConsumptionToDate: boolean;

  // chỉ cho chọn từ hai tháng quá khứ.
  minDateCreatedTimeForm = '';
  // chỉ cho chọn hai tháng tương lai.
  maxDateCreatedTimeTo = '';

  totalSC = 0;

  consumptionRequest = {
    fromDate: '',
    toDate: ''
  };
  chartOptionsConsumption: any;
  categoriesConsumptionDay: any[] = [];
  seriesConsumptionDay: Series[] = [];
  categoriesConsumptionWeek: any[] = [];
  seriesConsumptionWeek: Series[] = [];
  categoriesConsumptionMonth: any[] = [];
  seriesConsumptionMonth: Series[] = [];
  categoriesConsumptionQuarter: any[] = [];
  seriesConsumptionQuarter: Series[] = [];
  categoriesConsumptionYear: any[] = [];
  seriesConsumptionYear: Series[] = [];
  tooltipsConsumption: any[] = [];
  language = localStorage.getItem('__language');
  optionsSelect = 1; // 1 - Ngày; 2 - Tuần; 3 - Tháng
  // skeleton loading cục bộ cho từng khối dashboard
  loadingUserStat = true;
  loadingConsumption = true;
  loadingEnterpriseService = true;
  // createdTimeFrom: Date = new Date(moment().subtract(30, 'd').format('YYYY-MM-DD')); //new Date(2020, 7, 1, 0, 0, 0);
  // createdTimeTo: Date = new Date(moment(new Date()).format('YYYY-MM-DD')); //new Date(2020, 7, 31, 23, 59, 59);
  createdTimeFromCtrl = new FormControl(new Date());
  createdTimeToCtrl = new FormControl(new Date());
  createdDateErr = '';
  flagInvalidDate = false;

  consumptionFormGroup: FormGroup;
  // inValideToDateEmpty: String = '';
  // inValidToDateFormat: String = '';
  // inValideFormDateEmpty: String = '';
  // inValidFromDateFormat: String = '';
  // isValidFormDate: boolean = true;
  // isValidToDate: boolean = true;

  isValiTimeFromMaximum30 = false;
  isValiTimeToMaximum30 = false;

  minDateCreatedTimeFormOptionDay = '';
  maxDateCreatedTimeToOptionDay = '';
  isStorageDigContractExpired = false;
  isContractQuantityExpired = false;
  isContract1MBQuantityExpired = false;

  // DEFAULT LINKS
  SEARCH_MY_CREATED_DOCUMENT_LINK = '/home-enterprise/search-my-created-document';
  SEARCH_ENTERPRISE_CREATED_DOCUMENT_LINK = '/home-enterprise/search-document/';
  SEARCH_SIGNATURE_WAITING_LINK = '/home-enterprise/search-document-sign';
  SEARCH_WAITING_CONFIRM_LINK = '/home-enterprise/search-waiting-confirm-document';
  SEARCH_APPROVAL_WAITING_LINK = '/home-enterprise/search-approval-waiting-document';
  SEARCH_INITIAL_WAITING_LINK = '/home-enterprise/search-initial-waiting-document';
  SEARCH_RECEIVED_DOCUMENT_LINK = '/home-enterprise/search-document-receive/';
  ADD_DOCUMENT_LINK = '/home-enterprise/add-document';

  color_primary = '#F5222D';
  color_blue = '#678AF7';
  color_yellow = '#6BDAAE';
  maxContractChart = 1;
  maxSMSChart = 1;
  // max of week
  maxContractChartWeek = 1;
  maxSMSChartWeek = 1;
  // max of month
  maxContractChartMonth = 1;
  maxSMSChartMonth = 1;
  // max of month
  maxContractChartQuarter = 1;
  maxSMSChartQuarter = 1;
  // max of month
  maxContractChartYear = 1;
  maxSMSChartYear = 1;
  mesage = '';
  maxSizeSystem: number = 0;
  me: any;
  size150MB = 150*1024*1024;
  size10MB = 10*1024*1024;

  isNotAttestedUser = false;

  public valueTemp: any;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  document: any;

  private fromDateShouldBeValid(control: AbstractControl): ValidationErrors | null {
    // console.log("control:", control);
    // console.log("control.value:", control.value);
    // if ((control.value as string).indexOf(' ') >= 0) {
    //   return { shouldNotHaveSpaces: true }
    // }

    // If there is no validation failure, return null
    return null;
  }

  private customValidatorFromDate(control: AbstractControl): ValidationErrors {
    // console.log("control: ", control);
    // console.log("control.value: ", control.value);
    if (control.value) {
      const matches = control.value.match(/^\d{2}\/\d{2}\/\d{4}$/);
      // console.log("matches:", matches);
      return matches ? null : { invalidDate: true };
    } else {
      return null;
    }
  }

  private dateValidator(control: FormControl) {
    // console.log("control.value: ", control.value)
    if (control.value) {
      const matches = moment(control.value).format('DD-MM-YYYY').match(/^\d{2}\/\d{2}\/\d{4}$/);
      return matches ? null : { invalidDate: true };
    } else {
      return null;
    }
  }

  /**
   * Get error from date
   */
  getErrorDateMessageRange(pickerInput: string, isExpired?: boolean): string {
    // console.log("pickerInput: ", pickerInput)
    if (!pickerInput || pickerInput === '') {
      return null;
    }
    return this.message.getMessage('validation.format_of_date_consumption');
  }

  private myValidatorFromDate = (ctrl: FormControl): ValidationErrors | null => {
    // console.log(ctrl.value)
    const myDate = new Date(ctrl.value);
    // nếu không phải là nhập dữ liệu ngày tháng năm thì báo lỗi;
    return isNaN(myDate.getTime()) || myDate.getFullYear() > 9999 ? { dateInvalidFromDate: true } : null;
  };

  private myValidatorToDate = (ctrl: FormControl): ValidationErrors | null => {
    const myDate = new Date(ctrl.value);
    // nếu không phải là nhập dữ liệu ngày tháng năm thì báo lỗi;
    return isNaN(myDate.getTime()) || myDate.getFullYear() > 9999 ? { dateInvalidToDate: true } : null;
  };

  ngOnInit() {
    this.consumptionFormGroup = this.formBuilder.group({
      fromDate: [
        moment(this.defaultModelCreateTime.createdTimeFrom).format('YYYY-MM-DD'),
        [Validators.required]
      ],
      toDate: [
        moment(this.defaultModelCreateTime.createdTimeTo).format('YYYY-MM-DD'),
        [Validators.required]
      ],
    });


    this.subscription = this.notificationService.changePassword.subscribe((data) => {
      if (data) {
        this.getMe();
      }
    });

    setTimeout(() => {
      $('[data-toggle="popover"]').popover();
    }, 200);

    this.seriesConsumptionDay = this.seriesConsumptionWeek = this.seriesConsumptionMonth = this.seriesConsumptionQuarter = this.seriesConsumptionYear = [
      {
        name: this.message.getMessage('analysis.analysis_report_consumption.contract'),
        data: [],
        yAxis: 0,
        color: this.color_primary,
        marker: {
          symbol: 'circle',
          lineWidth: 2,
          radius: 5
        },
      },
      {
        name: this.message.getMessage('analysis.analysis_report_consumption.message'),
        data: [],
        yAxis: 1,
        color: this.color_blue,
        marker: {
          symbol: 'circle',
          lineWidth: 2,
          radius: 5
        },
      },
      {
        name: this.message.getMessage('analysis.analysis_report_consumption.timestamp'),
        data: [],
        yAxis: 1,
        color: this.color_yellow,
        marker: {
          symbol: 'circle',
          lineWidth: 2,
          radius: 5
        },
      }
    ];

    this.getMe();
    this.getMaxSizeSystem();
    // 3 API chạy song song; consumption phụ thuộc isBuySmsBccs sẽ được trim/vẽ lại khi enterprise-by-service trả về sau
    this.getDataCountNumberDocumentOfEnterpriseByService();
    this.DrawChart();

    // show/hide report dashboard report:
    if (this.permissions.length >= 8) {
      // user Admin show all khối --[2, 3, 4, 6, 0, 1, 2, 3, 4, 5, 6]
      // console.log("Admin")
      this.isShowByServiceReport = true;
      this.isShowEnterpriseReport = true;
      this.isShowUserReport = true;
      this.isShowPartnerReport = true;
      this.isShowByConsumptionReport = true;
    } else {
      if (this.permissions.indexOf(this.NORMAL_USER) !== -1 && AuthUtils.hasDocumentPermission(this.permissions) && this.permissions.indexOf(this.BUSSINESS_INFORMATION_MANAGEMENT) !== -1) {
        // user có quyền QLTL +  QLTTDN + ... --[0, 1, 5]
        // console.log("User co quyen QLTTDN + QLTL")
        this.isShowByServiceReport = true;
        this.isShowEnterpriseReport = true;
        this.isShowUserReport = true;
        this.isShowPartnerReport = true;
        this.isShowByConsumptionReport = true;
      } else {
        if (this.permissions.indexOf(this.NORMAL_USER) !== -1 && AuthUtils.hasDocumentPermission(this.permissions)) {
          // user có quyền QLTL show khối: DN mua DV + khối Người dùng --[1, 0]
          // console.log("User co quyen QLTL")
          this.isShowByServiceReport = false;
          this.isShowEnterpriseReport = true;
          this.isShowUserReport = true;
          this.isShowPartnerReport = true;
          this.isShowByConsumptionReport = false;
        }
        if (this.permissions.indexOf(this.NORMAL_USER) !== -1 && this.permissions.indexOf(this.BUSSINESS_INFORMATION_MANAGEMENT) !== -1) {
          // user có quyền QLTTDN show khối: Doanh nghiệp + khối Người dùng + Khối Đối tác --[5, 0]
          // console.log("User co quyen QLTTDN")
          this.isShowByServiceReport = true;
          this.isShowEnterpriseReport = false;
          this.isShowUserReport = true;
          this.isShowPartnerReport = false;
          this.isShowByConsumptionReport = true;
        }
      }
      /* tách qlhđ thành qlhđ tôi lập và qlhđ nhận từ đối tác */
      this.isShowEnterpriseReport = this.permissions.indexOf(this.DOCUMENT_CREATE_MANAGEMENT) !== -1;
      this.isShowPartnerReport = this.permissions.indexOf(this.DOCUMENT_RECEIVE_MANAGEMENT) !== -1;
    }
  }


  ngOnChanges() {
  }

  ngAfterViewInit() {
    // subscribe function ReloadDataChart();
    if (this.reloadEventEmitterService.subscriptionVar == undefined) {
      this.reloadEventEmitterService.subscriptionVar = this.reloadEventEmitterService.invokeAnalysisReportEnterpriseFunction.subscribe(() => {
        this.ReloadDataChart();
      });
    }

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
        }
      }
    );
  }

  ngOnDestroy() {
    this.subscribeMediaBreakPointService.unsubscribe();
    this.subscription.unsubscribe();
  }

  ReloadDataChart = function () {
    window.location.reload();
    setTimeout(() => {
      this.DrawChart();
    }, 500);

    // setter text tooltip default:
    $('#show_warning_quanity_contract').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_used_up_soon_data_content'));
    $('.txt_show_warning_quanity_contract').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_used_up_soon'));

    $('#show_warning_quanity_contract_1mb').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_1MB_used_up_soon_data_content'));
    $('.txt_show_warning_quanity_contract_1mb').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_1MB_used_up_soon'));

    $('#show_warning_storage_digital_contract').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_storage_dig_contracts_has_expired'));
    $('.txt_show_warning_storage_digital_contract').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_storage_dig_contracts_has_expired'));

    $('#show_warning_quanity_money').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_money_used_up_soon_data_content'));
    $('.txt_show_warning_quanity_money').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_money_used_up_soon'));

    $('#show_warning_quanity_tsa_money').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_money_used_up_soon_data_content'));
    $('.txt_show_warning_quanity_tsa_money').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tsa_money_used_up_soon'));

    $('#show_warning_quanity_ekyc').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_used_up_soon_data_content'));
    $('.txt_show_warning_quanity_ekyc').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_used_up_soon'));

    $('#show_warning_quanity_ekyc_advanced').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_advanced_used_up_soon_data_content'));
    $('.txt_show_warning_quanity_ekyc_advanced').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_advanced_used_up_soon'));

    $('#show_warning_quanity_tindy').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tindy_used_up_soon'));
    $('.txt_show_warning_quanity_tindy').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tindy_used_up_soon'));

    $('#show_warning_quanity_mytime').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mytime_used_up_soon'));
    $('.txt_show_warning_quanity_mytime').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mytime_used_up_soon'));

    $('#show_warning_quanity_mysign').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mysign_used_up_soon'));
    $('.txt_show_warning_quanity_mysign').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mysign_used_up_soon'));

    // setter text tooltip when contract and messeage has expired:
    if (this.enterpriseByService.contract_quantity == 0) {
      $('#show_warning_quanity_contract').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_has_expired'));
      $('.txt_show_warning_quanity_contract').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_has_expired'));
    }

    if (this.enterpriseByService.contract_quantity == 0) {
      $('#show_warning_quanity_contract_1mb').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_1mb_has_expired'));
      $('.txt_show_warning_quanity_contract_1mb').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_1mb_has_expired'));
    }

    if (this.enterpriseByService.storage_digital_contract == 0) {
      $('#show_warning_storage_digital_contract').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_storage_dig_contracts_has_expired'));
      $('.txt_show_warning_storage_digital_contract').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_storage_dig_contracts_has_expired'));
    }

    if (this.enterpriseByService.money_quantity == 0) {
      $('#show_warning_quanity_money').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_money_has_expired'));
      $('.txt_show_warning_quanity_money').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_money_has_expired'));
    }
    if (this.enterpriseByService.tsa_money_quantity == 0) {
      $('#show_warning_quanity_tsa_money').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tsa_money_has_expired'));
      $('.txt_show_warning_quanity_tsa_money').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tsa_money_has_expired'));
    }
    if (this.enterpriseByService.ekyc_quantity == 0) {
      $('#show_warning_quanity_ekyc').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_has_expired'));
      $('.txt_show_warning_quanity_ekyc').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_has_expired'));
    }
    if (this.enterpriseByService.ekyc_advanced_quantity == 0) {
      $('#show_warning_quanity_ekyc_advanced').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_advanced_has_expired'));
      $('.txt_show_warning_quanity_ekyc_advanced').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_advanced_has_expired'));
    }
    if (this.enterpriseByService.tindy_quantity == 0) {
      $('#show_warning_quanity_tindy').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tindy_has_expired'));
      $('.txt_show_warning_quanity_tindy').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tindy_has_expired'));
    }
    if (this.enterpriseByService.mytime_quantity == 0) {
      $('#show_warning_quanity_mytime').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mytime_has_expired'));
      $('.txt_show_warning_quanity_mytime').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mytime_has_expired'));
    }
    if (this.enterpriseByService.mysign_quantity == 0) {
      $('#show_warning_quanity_mysign').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mysign_has_expired'));
      $('.txt_show_warning_quanity_mysign').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mysign_has_expired'));
    }

  };

  DrawChart() {
    this.getDataCountNumberDocument();
    // this.getDataCountNumberDocumentforEnterprise();
    this.getDataConsumptionHistory(this.optionsSelect);
  }

  // Doanh nghiệp
  getDataCountNumberDocumentforEnterprise() {
    this.contractService.getDataCountNumberDocumentforEnterpriseService().subscribe(
      response => {
        // console.log("ENTERPRISE res:", response.data);
        if (Object.keys(response.data).length !== 0 && response.data.constructor === Object) {
          const data = Object.keys(response.data).map(key => ({
            value: key,
            name: (key === 'totalDocumentsSigned' ? this.message.getMessage('analysis.analysis_report_enterprise.pie_chart.signed') + ' (' + response.data[key] + ')' :
              key === 'totalDocumentsWaitingForPartnersToSign' ? this.message.getMessage('analysis.analysis_report_enterprise.pie_chart.waiting_partner_signed') + ' (' + response.data[key] + ')' :
                key === 'totalDocumentsRejectedByPartners' ? this.message.getMessage('analysis.analysis_report_enterprise.pie_chart.partner_refused_to_sign') + ' (' + response.data[key] + ')' :
                  key === 'totalDocumentsFinish' ? this.message.getMessage('analysis.analysis_report_enterprise.pie_chart.finish') + ' (' + response.data[key] + ')' : key),
            y: response.data[key],
            url: 'home-enterprise/search-document' + '?status=' + encodeURIComponent(key)
          }));
          const dataOptimineEnterprise = data.filter(x => x.value != 'Email' && x.value != 'CompanyName' && x.value != 'TaxCode');
          // console.log("ENTERPRISE:", dataOptimineEnterprise);

          if (dataOptimineEnterprise[0].y == 0 && dataOptimineEnterprise[1].y == 0 && dataOptimineEnterprise[2].y == 0 && dataOptimineEnterprise[3].y == 0) {
            $('#userPieChart').empty();
            $('#userPieChart').append('<div class="no-data-chart"><img alt="time" src="./assets/images/no-data-chart.svg" width="100" height="100"><span>' + this.message.getMessage('analysis.no_data') + '</span></div>');
          } else {
            // Draw
            this.EnterprisePieChart(dataOptimineEnterprise, this.colorsPieCharts, this.message.getMessage('analysis.no_data'));
            // this.BCTPieChart(dataOptimineEnterprise, this.colorsBCTPieCharts, this.message.getMessage('analysis.no_data'));
          }
        }
      }
    );
  }

  getAmountByStatus(status, data) {
    const amountdata = data.filter(item => item.status == status);
    if (amountdata.length == 0) {
      return 0;
    }
    return amountdata[0].amount;
  }

  // Người dùng
  getDataCountNumberDocument() {
    this.loadingUserStat = true;
    const params = {
      fromDate: this.datepipe.transform(moment(this.defaultModelCreateTime.createdTimeFrom).startOf('day').toISOString(), 'yyyy-MM-dd'),
      toDate: this.datepipe.transform(moment(this.defaultModelCreateTime.createdTimeTo).endOf('day').toISOString(), 'yyyy-MM-dd')
    };
    this.contractService.getDataCountNumberDocumentforUserService(params)
      .pipe(finalize(() => this.loadingUserStat = false))
      .subscribe(
      response => {
        let {
          statisticDocumentEnterpriseCreated,
          statisticDocumentEnterpriseReceive,
          statisticDocumentUsers,
          statisticDocumentUsersHandle,
          statisticDocumentSendBCT
        } = response.data;

        console.log('response.data', response.data);

        statisticDocumentEnterpriseReceive = statisticDocumentEnterpriseReceive || [];
        statisticDocumentUsers = statisticDocumentUsers || [];
        statisticDocumentUsersHandle = statisticDocumentUsersHandle || [];
        statisticDocumentEnterpriseCreated = statisticDocumentEnterpriseCreated || [];
        statisticDocumentSendBCT = statisticDocumentSendBCT || [];
        this.documentEnterpriseReceive.processing = this.getAmountByStatus(2, statisticDocumentEnterpriseReceive);
        this.documentEnterpriseReceive.rejected = this.getAmountByStatus(3, statisticDocumentEnterpriseReceive);
        this.documentEnterpriseReceive.signed = this.getAmountByStatus(4, statisticDocumentEnterpriseReceive);
        this.documentEnterpriseReceive.waitSetSignFlow = this.getAmountByStatus(6, statisticDocumentEnterpriseReceive);
        const userData = [
          {
            name: this.message.getMessage('search_form.draft'),
            y: this.getAmountByStatus(EnumContractStatus.DRAFT, statisticDocumentUsers),
            drilldown: this.message.getMessage('search_form.draft'),
            url: this.SEARCH_MY_CREATED_DOCUMENT_LINK,
            status: EnumContractStatus.DRAFT,
            router: this.router
          },
          {
            name: this.message.getMessage('search_form.processing'),
            y: this.getAmountByStatus(EnumContractStatus.PROCESSING, statisticDocumentUsers),
            drilldown: this.message.getMessage('search_form.processing'),
            url: this.SEARCH_MY_CREATED_DOCUMENT_LINK,
            status: EnumContractStatus.PROCESSING,
            router: this.router
          },
          {
            name: this.message.getMessage('search_form.denied_sign'),
            y: this.getAmountByStatus(EnumContractStatus.REJECTED, statisticDocumentUsers),
            drilldown: this.message.getMessage('search_form.denied_sign'),
            url: this.SEARCH_MY_CREATED_DOCUMENT_LINK,
            status: EnumContractStatus.REJECTED,
            router: this.router
          },
          {
            name: this.message.getMessage('search_form.finish'),
            y: this.getAmountByStatus(EnumContractStatus.FINISHED, statisticDocumentUsers),
            drilldown: this.message.getMessage('search_form.finish'),
            url: this.SEARCH_MY_CREATED_DOCUMENT_LINK,
            status: EnumContractStatus.FINISHED,
            router: this.router
          },
          {
            name: this.message.getMessage('search_form.cancelled'),
            y: this.getAmountByStatus(EnumContractStatus.CANCELLED, statisticDocumentUsers),
            drilldown: this.message.getMessage('search_form.cancelled'),
            url: this.SEARCH_MY_CREATED_DOCUMENT_LINK,
            status: EnumContractStatus.CANCELLED,
            router: this.router
          }
        ];

        const userHandleData = [
          {
            name: this.message.getMessage('left_menu.enterprise_waiting_initial_doc'),
            y: this.getAmountByStatus(EnumContractUserRole.INITIAL, statisticDocumentUsersHandle),
            drilldown: this.message.getMessage('left_menu.enterprise_waiting_initial_doc'),
            url: this.SEARCH_INITIAL_WAITING_LINK,
            router: this.router
          },
          {
            name: this.message.getMessage('left_menu.enterprise_waiting_approve_doc'),
            y: this.getAmountByStatus(EnumContractUserRole.APPROVE, statisticDocumentUsersHandle),
            drilldown: this.message.getMessage('left_menu.enterprise_waiting_approve_doc'),
            url: this.SEARCH_APPROVAL_WAITING_LINK,
            router: this.router
          },
          {
            name: this.message.getMessage('left_menu.enterprise_waiting_signing_doc'),
            y: this.getAmountByStatus(EnumContractUserRole.SIGN, statisticDocumentUsersHandle),
            drilldown: this.message.getMessage('left_menu.enterprise_waiting_signing_doc'),
            url: this.SEARCH_SIGNATURE_WAITING_LINK,
            router: this.router
          }
        ];

        const enterpriseCreated = [
          {
            name: this.message.getMessage('analysis.analysis_report_customer_v1.processing') + ' ' + '(' + this.getAmountByStatus(EnumContractStatus.PROCESSING, statisticDocumentEnterpriseCreated) + ')',
            y: this.getAmountByStatus(EnumContractStatus.PROCESSING, statisticDocumentEnterpriseCreated),
            drilldown: this.message.getMessage('search_form.processing'),
            url: this.SEARCH_ENTERPRISE_CREATED_DOCUMENT_LINK,
            status: EnumContractStatus.PROCESSING,
            fromDate: params.fromDate,
            toDate: params.toDate,
            router: this.router
          },
          {
            name: this.message.getMessage('analysis.analysis_report_customer_v1.denied_sign') + ' ' + '(' + this.getAmountByStatus(EnumContractStatus.REJECTED, statisticDocumentEnterpriseCreated) + ')',
            y: this.getAmountByStatus(EnumContractStatus.REJECTED, statisticDocumentEnterpriseCreated),
            drilldown: this.message.getMessage('search_form.denied_sign'),
            url: this.SEARCH_ENTERPRISE_CREATED_DOCUMENT_LINK,
            status: EnumContractStatus.REJECTED,
            fromDate: params.fromDate,
            toDate: params.toDate,
            router: this.router
          },
          {
            name: this.message.getMessage('analysis.analysis_report_customer_v1.finish') + ' ' + '(' + this.getAmountByStatus(EnumContractStatus.FINISHED, statisticDocumentEnterpriseCreated) + ')',
            y: this.getAmountByStatus(EnumContractStatus.FINISHED, statisticDocumentEnterpriseCreated),
            drilldown: this.message.getMessage('search_form.finish'),
            url: this.SEARCH_ENTERPRISE_CREATED_DOCUMENT_LINK,
            status: EnumContractStatus.FINISHED,
            fromDate: params.fromDate,
            toDate: params.toDate,
            router: this.router
          },
          {
            name: this.message.getMessage('analysis.analysis_report_customer_v1.cancelled') + ' ' + '(' + this.getAmountByStatus(EnumContractStatus.CANCELLED, statisticDocumentEnterpriseCreated) + ')',
            y: this.getAmountByStatus(EnumContractStatus.CANCELLED, statisticDocumentEnterpriseCreated),
            drilldown: this.message.getMessage('search_form.cancelled'),
            url: this.SEARCH_ENTERPRISE_CREATED_DOCUMENT_LINK,
            status: EnumContractStatus.CANCELLED,
            fromDate: params.fromDate,
            toDate: params.toDate,
            router: this.router
          }
        ];

        const bctCreated = [
          {
            name: this.message.getMessage('analysis.analysis_report_bct.processing') + ' ' + '(' + this.getAmountByStatus(EnumContractStatus.PROCESSING, statisticDocumentSendBCT) + ')',
            y: this.getAmountByStatus(EnumContractSendBCTStatus.PROCESSING, statisticDocumentSendBCT),
            drilldown: this.message.getMessage('search_form.processing'),
            url: this.SEARCH_ENTERPRISE_CREATED_DOCUMENT_LINK,
            BCTConfirmStatus: EnumContractSendBCTStatus.PROCESSING,
            fromDate: params.fromDate,
            toDate: params.toDate,
            router: this.router
          },
          {
            name: this.message.getMessage('analysis.analysis_report_bct.resolve') + ' ' + '(' + this.getAmountByStatus(EnumContractStatus.FINISHED, statisticDocumentSendBCT) + ')',
            y: this.getAmountByStatus(EnumContractSendBCTStatus.FINISHED, statisticDocumentSendBCT),
            drilldown: this.message.getMessage('search_form.finish'),
            url: this.SEARCH_ENTERPRISE_CREATED_DOCUMENT_LINK,
            BCTConfirmStatus: EnumContractSendBCTStatus.FINISHED,
            fromDate: params.fromDate,
            toDate: params.toDate,
            router: this.router
          },
          {
            name: this.message.getMessage('analysis.analysis_report_bct.reject') + ' ' + '(' + this.getAmountByStatus(EnumContractStatus.REJECTED, statisticDocumentSendBCT) + ')',
            y: this.getAmountByStatus(EnumContractSendBCTStatus.ERROR, statisticDocumentSendBCT),
            drilldown: this.message.getMessage('search_form.denied_sign'),
            url: this.SEARCH_ENTERPRISE_CREATED_DOCUMENT_LINK,
            BCTConfirmStatus: EnumContractSendBCTStatus.ERROR,
            fromDate: params.fromDate,
            toDate: params.toDate,
            router: this.router
          },
        ];

        // Nếu là tài khoản không chứng thực: true => sContract
        if (this.isNotAttestedUser) {
          userData.splice(3, 0, {
            name: this.message.getMessage('search_form.wait_confirm_enterprice_no_moit'),
            y: this.getAmountByStatus(EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT, statisticDocumentUsers),
            drilldown: this.message.getMessage('search_form.wait_confirm_enterprice_no_moit'),
            url: this.SEARCH_MY_CREATED_DOCUMENT_LINK,
            status: EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT,
            router: this.router
          });

          userHandleData.push({
            name: this.message.getMessage('left_menu.enterprise_waiting_confirm_doc'),
            y: this.getAmountByStatus(EnumContractUserRole.CONFIRM, statisticDocumentUsersHandle),
            drilldown: this.message.getMessage('left_menu.enterprise_waiting_confirm_doc'),
            url: this.SEARCH_WAITING_CONFIRM_LINK,
            router: this.router
          });

          enterpriseCreated.splice(2, 0, {
            name: this.message.getMessage('analysis.analysis_report_customer_v1.wait_confirm_enterprice_no_moit') + ' ' + '(' + this.getAmountByStatus(EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT, statisticDocumentEnterpriseCreated) + ')',
            y: this.getAmountByStatus(EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT, statisticDocumentEnterpriseCreated),
            drilldown: this.message.getMessage('search_form.wait_confirm_enterprice_no_moit'),
            url: this.SEARCH_ENTERPRISE_CREATED_DOCUMENT_LINK,
            status: EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT,
            fromDate: params.fromDate,
            toDate: params.toDate,
            router: this.router
          });
          bctCreated.splice(2, 0, {
            name: this.message.getMessage('analysis.analysis_report_customer_v1.wait_confirm_enterprice_no_moit') + ' ' + '(' + this.getAmountByStatus(EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT, statisticDocumentSendBCT) + ')',
            y: this.getAmountByStatus(EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT, statisticDocumentSendBCT),
            drilldown: this.message.getMessage('search_form.wait_confirm_enterprice_no_moit'),
            url: this.SEARCH_ENTERPRISE_CREATED_DOCUMENT_LINK,
            BCTConfirmStatus: EnumContractSendBCTStatus.FINISHED,
            fromDate: params.fromDate,
            toDate: params.toDate,
            router: this.router
          });
        }

        this.showChartBCT = bctCreated.some(e => e.y !== 0)
        this.showChartEnterprise = enterpriseCreated.some(e => e.y !== 0)

        // Draw
        this.UserColumnChart(userData, this.message.getMessage('analysis.no_data'));
        this.UserHandleColumnChart(userHandleData, this.message.getMessage('analysis.no_data'));
        this.EnterprisePieChart(enterpriseCreated, this.colorsPieCharts, this.message.getMessage('analysis.no_data'));
        this.BCTPieChart(bctCreated, this.colorsBCTPieCharts, this.message.getMessage('analysis.no_data'));
      }
    );
  }

  // Đối tác
  getDataCountNumberDocumentOfPartner() {
    this.contractService.getDataCountNumberDocumentOfPartnerService().subscribe(
      response => {
        // console.log("PARTNER:", response.data);
        if (Object.keys(response.data).length !== 0 && response.data.constructor === Object) {
          this.partner.totalDocumentsWaitingForProgressing = response.data.totalDocumentsWaitingForProgressing;
          this.partner.totalDocumentsFinish = response.data.totalDocumentsFinish;
          this.partner.totalDocumentsDenied = response.data.totalDocumentsDenied;
        } else {
          this.partner.totalDocumentsWaitingForProgressing = 0;
          this.partner.totalDocumentsFinish = 0;
          this.partner.totalDocumentsDenied = 0;
        }
      }
    );
  }

  // Doanh nghiệp mua Dịch vụ
  getDataCountNumberDocumentOfEnterpriseByService() {
    this.loadingEnterpriseService = true;
    this.contractService.getDataCountNumberDocumentOfEnterpriseByService()
      .pipe(finalize(() => this.loadingEnterpriseService = false))
      .subscribe(
      response => {
        if(response && response.data) {
          this.enterpriseByService.cpAccountCode = response.data.cpAccountCode;
          console.log('ENTERPRISE BY SERVICE:', response.data);
          if (Object.keys(response.data).length !== 0 && response.data.constructor === Object) {
            this.enterpriseByService.contract_quantity = response.data.contractQuantity;
            this.enterpriseByService.sms_quantity = response.data.smsQuantity;
            // lấy số lượng ký ekyc và ekyc nâng cao: số lượng >=0 -> đã mua, số lượng undefined -> chưa mua
            if (response.data.ekycQuantity !== undefined) {
              this.enterpriseByService.ekyc_quantity = response.data.ekycQuantity;
            } else {
              this.isBoughtEkyc = false;
            }
            if (response.data.advanceEkycQuantity !== undefined) {
              this.enterpriseByService.ekyc_advanced_quantity = response.data.advanceEkycQuantity;
            } else {
              this.isBoughtEkycAdvanced = false;
            }
            if (response.data.smsTotalMoney !== undefined) {
              this.enterpriseByService.money_quantity = response.data.smsTotalMoney;
            } else {
              this.isBuySmsBccs = false;
            }
            if (response.data.tsaTotalMoney !== undefined) {
              this.enterpriseByService.tsa_money_quantity = response.data.tsaTotalMoney;
            } else {
              this.isBuyTsaSmsBccs = false;
            }
            // lấy số lượng hợp đồng số hóa : số lượng >=0 -> đã mua, số lượng undefined -> chưa mua
            if (response.data.storageDigitalContract !== undefined) {
              this.setValueStorageDigitalContract(response);
            } else {
              this.isStorageDigitalContract = false;
            }
             // lấy số lượng dung luong tai tep : số lượng >=0 -> đã mua, số lượng undefined -> chưa mua
             if (response.data.biggerThan10MBFileSize !== undefined) {
               this.biggerThan10MBFileSize = response.data.biggerThan10MBFileSize;
               if (this.biggerThan10MBFileSize > 0) {
                this.messageNotify = this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_storage_than10MB_used_up_soon');
               } else {
                this.messageNotify = this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_storage_than10MB_has_expired');
               }
              this.setValueStorageThan10Mb(response);
              this.computeFileSizeMessage();
            } else {
              this.isStorageBiggerThan10MBFileSize = false;
            }

            // Tài nguyên Tindy
            if (response.data.tindyQuantity !== undefined) {
              this.enterpriseByService.tindy_quantity = response.data.tindyQuantity;
            } else {
              this.isBoughtTindy = false;
            }

            // Tài nguyên Mytime
            if (response.data.mytimeQuantity !== undefined) {
              this.enterpriseByService.mytime_quantity = response.data.mytimeQuantity;
            } else {
              this.isBoughtMytime = false;
            }

            // Tài nguyên Mysign
            if (response.data.mysignQuantity !== undefined) {
              this.enterpriseByService.mysign_quantity = response.data.mysignQuantity;
            } else {
              this.isBoughtMysign = false;
            }

            // Check hết hạn số hóa không
            if (response.data.expireDateStorageDigContract !== undefined && response.data.expireDateStorageDigContract !== null && this.isExpiredDate(response.data.expireDateStorageDigContract)) {
              this.isStorageDigContractExpired = true;
            } else {
              this.isStorageDigContractExpired = false;
              this.storageDigContractExpireTitle = this.formatDate(new Date(response.data.expireDateStorageDigContract));
            }
            // Check hết hạn hợp đồng không
            if (response.data.expireDateContractQuantity !== undefined && response.data.expireDateContractQuantity !== null && this.isExpiredDate(response.data.expireDateContractQuantity)) {
              this.isContractQuantityExpired = true;
            } else {
              this.isContractQuantityExpired = false;
              this.ContractQuantityExpireTitle = this.formatDate(new Date(response.data.expireDateContractQuantity));
            }

            // lấy số lượng hợp đồng 1MB
            this.enterpriseByService.contract_1mb_quantity = response.data.contract1MbQuantity;
            // Check hết hạn hợp đồng 1MB không
            if (response.data.expireDateContract1MbQuantity !== undefined && response.data.expireDateContract1MbQuantity !== null && this.isExpiredDate(response.data.expireDateContract1MbQuantity)) {
              this.isContract1MBQuantityExpired = true;
            } else {
              this.isContract1MBQuantityExpired = false;
              this.Contract1MBQuantityExpireTitle = this.formatDate(new Date(response.data.expireDateContract1MbQuantity));
            }
            this.isBuyContract1Mb = response.data.isBuyContract1Mb;
            this.isShowWarningQuanitySMS = response.data.warningSmsQuantity;
            this.isShowWarningQuanityContract = response.data.warningContractQuantity;
            this.isShowWarningQuanityMoney = response.data.warningSmsTotalMoney;
            this.isShowWarningQuanityTsaMoney = response.data.warningTsaTotalMoney;
            this.isShowWarningQuanityEkyc = response.data.warningEkycQuantity;
            this.isShowWarningQuanityEkycAdvanced = response.data.warningAdvanceEkycQuantity;
            this.isShowWarningQuanityTindy = response.data.warningTindyQuantity;
            this.isShowWarningQuanityMytime = response.data.warningMytimeQuantity;
            this.isShowWarningQuanityMysign = response.data.warningMysignQuantity;
            this.isShowWarningStorageDigitalContract = response.data.warningStorageDigContract;
            this.isShowWarningStorageThan10MBFileSize = response.data.warningBiggerThan10MBFileSizeQuantity;
            this.isShowWarningExpireDigContract = response.data.warningStorageDigContractExpire;
            this.isShowWarningExpiredThan10MBFileSize = response.data.warningBiggerThan10MBFileSizeExpire;
            this.isShowWarningExpireContractQuantity = response.data.warningContractQuantityExpire;
            this.isTransferSmsToTsa = response.data.isTransferSmsToTsa;
            this.isTransferTsaToSms = response.data.isTransferTsaToSms;
            this.warningRemittanceSMS = response.data.warningRemittanceSMS;
            this.warningRemittanceTSA = response.data.warningRemittanceTSA;
            // hợp đồng 1MB
            this.isShowWarningQuanityContract1MB = response.data.warningContract1MbQuantity;
            this.isShowWarningExpireContract1MBQuantity = response.data.warningContract1MbQuantityExpire;

            // gọi song song: nếu consumption đã vẽ trước mà chưa mua SMS thì trim series + vẽ lại
            if (!this.isBuySmsBccs && !this.loadingConsumption && this.chartOptionsConsumption) {
              this.trimConsumptionSeries();
              this.ConsumptionLineChart(this.getSeriesByOption(this.optionsSelect), this.getCategoriesByOption(this.optionsSelect), this.optionsSelect);
            }

            // setter text tooltip default:
            $('#show_warning_quanity_contract').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_used_up_soon'));
            $('.txt_show_warning_quanity_contract').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_used_up_soon'));

            $('#show_warning_quanity_contract_1mb').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_1MB_used_up_soon'));
            $('.txt_show_warning_quanity_contract_1mb').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_1MB_used_up_soon'));
            $('#show_warning_storage_digital_contract').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_storage_digital_contracts_used_up_soon'));
            $('.txt_show_warning_storage_digital_contract').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_storage_digital_contracts_used_up_soon'));
            $('#show_warning_quanity_money').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_money_used_up_soon'));
            $('.txt_show_warning_quanity_money').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_money_used_up_soon'));
            $('#show_warning_quanity_tsa_money').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tsa_money_used_up_soon'));
            $('.txt_show_warning_quanity_tsa_money').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tsa_money_used_up_soon'));
            $('#show_warning_quanity_ekyc').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_used_up_soon'));
            $('.txt_show_warning_quanity_ekyc').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_used_up_soon'));
            $('#show_warning_quanity_ekyc_advanced').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_advanced_used_up_soon'));
            $('.txt_show_warning_quanity_ekyc_advanced').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_advanced_used_up_soon'));

            $('#show_warning_quanity_tindy').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tindy_used_up_soon'));
            $('.txt_show_warning_quanity_tindy').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tindy_used_up_soon'));

            $('#show_warning_quanity_mytime').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mytime_used_up_soon'));
            $('.txt_show_warning_quanity_mytime').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mytime_used_up_soon'));

            $('#show_warning_quanity_mysign').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mysign_used_up_soon'));
            $('.txt_show_warning_quanity_mysign').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mysign_used_up_soon'));

            // setter text tooltip when contract and messeage has expired:
            if (this.enterpriseByService.contract_quantity === 0 || this.enterpriseByService.contract_quantity == null) {
              $('#show_warning_quanity_contract').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_has_expired'));
              $('.txt_show_warning_quanity_contract').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_has_expired'));
            }

            if (this.enterpriseByService.contract_1mb_quantity === 0 || this.enterpriseByService.contract_1mb_quantity == null) {
              $('#show_warning_quanity_contract_1mb').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_1mb_has_expired'));
              $('.txt_show_warning_quanity_contract_1mb').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_contracts_1mb_has_expired'));
            }
            if (this.enterpriseByService.storage_digital_contract === 0 || this.enterpriseByService.storage_digital_contract == null) {
              $('#show_warning_storage_digital_contract').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_storage_dig_contracts_has_expired'));
              $('.txt_show_warning_storage_digital_contract').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_storage_dig_contracts_has_expired'));
            }
            if (this.enterpriseByService.money_quantity === 0 || this.enterpriseByService.money_quantity == null) {
              $('#show_warning_quanity_money').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_money_has_expired'));
              $('.txt_show_warning_quanity_money').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_money_has_expired'));
            }
            if (this.enterpriseByService.tsa_money_quantity === 0 || this.enterpriseByService.tsa_money_quantity == null) {
              $('#show_warning_quanity_tsa_money').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tsa_money_has_expired'));
              $('.txt_show_warning_quanity_tsa_money').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tsa_money_has_expired'));
            }
            if (this.enterpriseByService.ekyc_quantity === 0 || this.enterpriseByService.ekyc_quantity == null) {
              $('#show_warning_quanity_ekyc').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_has_expired'));
              $('.txt_show_warning_quanity_ekyc').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_has_expired'));
            }
            if (this.enterpriseByService.ekyc_advanced_quantity === 0 || this.enterpriseByService.ekyc_advanced_quantity == null) {
              $('#show_warning_quanity_ekyc_advanced').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_advanced_has_expired'));
              $('.txt_show_warning_quanity_ekyc_advanced').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_ekyc_advanced_has_expired'));
            }

            if (this.enterpriseByService.tindy_quantity === 0 || this.enterpriseByService.tindy_quantity == null) {
              $('#show_warning_quanity_tindy').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tindy_has_expired'));
              $('.txt_show_warning_quanity_tindy').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_tindy_has_expired'));
            }

            if (this.enterpriseByService.mytime_quantity === 0 || this.enterpriseByService.mytime_quantity == null) {
              $('#show_warning_quanity_mytime').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mytime_has_expired'));
              $('.txt_show_warning_quanity_mytime').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mytime_has_expired'));
            }

            if (this.enterpriseByService.mysign_quantity === 0 || this.enterpriseByService.mysign_quantity == null) {
              $('#show_warning_quanity_mysign').attr('data-content', this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mysign_has_expired'));
              $('.txt_show_warning_quanity_mysign').html(this.message.getMessage('analysis.analysis_report_enterprise.the_number_of_mysign_has_expired'));
            }
          }
        }
      }
    );
  }

  onClickPageNavigationDetailItem(item) {
    // return location.href = "home-enterprise/search-document-receive?status=" + item;
    const params = {
      fromDate: this.datepipe.transform(moment(this.defaultModelCreateTime.createdTimeFrom).startOf('day').toISOString(), 'yyyy-MM-dd'),
      toDate: this.datepipe.transform(moment(this.defaultModelCreateTime.createdTimeTo).endOf('day').toISOString(), 'yyyy-MM-dd')
    };
    this.router.navigate([this.SEARCH_RECEIVED_DOCUMENT_LINK], {
      queryParams: {
        progressStatus: item,
        receivedTimeFrom: params.fromDate,
        receivedTimeTo: params.toDate
      }
    });
  }

  mapMarkerChart(valueCharts) {
    return valueCharts.map((e: any) => ({
      ...e,
      marker: {
        symbol: 'circle',
        lineWidth: 2,
        radius: 5
      },
    }));
  }

  getDataConsumptionHistory(option: number) {
    this.loadingConsumption = true;
    this.seriesConsumptionDay = [];
    this.categoriesConsumptionDay = [];
    this.seriesConsumptionWeek = [];
    this.categoriesConsumptionWeek = [];
    this.seriesConsumptionMonth = [];
    this.categoriesConsumptionMonth = [];
    this.seriesConsumptionQuarter = [];
    this.categoriesConsumptionQuarter = [];
    this.seriesConsumptionYear = [];
    this.categoriesConsumptionYear = [];
    this.consumptionRequest = {
      fromDate: this.datepipe.transform(moment(this.defaultModelCreateTime.createdTimeFrom).startOf('day').toISOString(), 'yyyy-MM-dd 00:00:00'),
      toDate: this.datepipe.transform(moment(this.defaultModelCreateTime.createdTimeTo).endOf('day').toISOString(), 'yyyy-MM-dd hh:mm:ss')
    };

    this.contractService.getDataConsumptionHistoryService(this.consumptionRequest)
      .pipe(finalize(() => this.loadingConsumption = false))
      .subscribe(
      response => {
        console.log(response);

        // get data for Day, Week, Month
        const datas = response.data.Day || [];
        const dataWeek = response.data.Week || [];
        const dataMonth = response.data.Month || [];
        const dataQuarter = response.data.Quarter || [];
        const dataYear = response.data.Year || [];
        this.seriesConsumptionDay = this.mapMarkerChart([
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.contract'),
            data: this.getAmountContractByDays(1, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, datas.filter(x => x.service === 'CONTRACT')),
            yAxis: 0,
            color: this.color_primary
          },
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.message'),
            data: this.getAmountContractByDays(2, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, datas.filter(x => x.service === 'SMS')),
            yAxis: 1,
            color: this.color_blue
          },
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.timestamp'),
            data: this.getAmountContractByDays(3, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, datas.filter(x => x.service === 'SERVICE_MONEY_TIMESTAMP')),
            yAxis: 1,
            color: this.color_yellow
          }
        ]);
        this.seriesConsumptionWeek = this.mapMarkerChart([
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.contract'),
            data: this.getAmountContractByWeeks(1, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataWeek.filter(x => x.service === 'CONTRACT')),
            yAxis: 0,
            color: this.color_primary
          },
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.message'),
            data: this.getAmountContractByWeeks(2, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataWeek.filter(x => x.service === 'SMS')),
            yAxis: 1,
            color: this.color_blue
          },
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.timestamp'),
            data: this.getAmountContractByWeeks(3, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataWeek.filter(x => x.service === 'SERVICE_MONEY_TIMESTAMP')),
            yAxis: 1,
            color: this.color_yellow,
          }
        ]);
        this.seriesConsumptionMonth = this.mapMarkerChart([
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.contract'),
            data: this.getAmountContractByMonths(1, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataMonth.filter(x => x.service === 'CONTRACT')),
            yAxis: 0,
            color: this.color_primary
          },
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.message'),
            data: this.getAmountContractByMonths(2, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataMonth.filter(x => x.service === 'SMS')),
            yAxis: 1,
            color: this.color_blue
          },
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.timestamp'),
            data: this.getAmountContractByMonths(3, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataMonth.filter(x => x.service === 'SERVICE_MONEY_TIMESTAMP')),
            yAxis: 1,
            color: this.color_yellow,
          }
        ]);
        this.seriesConsumptionQuarter = this.mapMarkerChart([
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.contract'),
            data: this.getAmountContractByQuarters(1, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataQuarter.filter(x => x.service === 'CONTRACT')),
            yAxis: 0,
            color: this.color_primary
          },
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.message'),
            data: this.getAmountContractByQuarters(2, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataQuarter.filter(x => x.service === 'SMS')),
            yAxis: 1,
            color: this.color_blue
          },
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.timestamp'),
            data: this.getAmountContractByQuarters(3, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataQuarter.filter(x => x.service === 'SERVICE_MONEY_TIMESTAMP')),
            yAxis: 1,
            color: this.color_yellow,
          }
        ]);
        this.seriesConsumptionYear = this.mapMarkerChart([
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.contract'),
            data: this.getAmountContractByYears(1, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataYear.filter(x => x.service === 'CONTRACT')),
            yAxis: 0,
            color: this.color_primary
          },
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.message'),
            data: this.getAmountContractByYears(2, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataYear.filter(x => x.service === 'SMS')),
            yAxis: 1,
            color: this.color_blue
          },
          {
            name: this.message.getMessage('analysis.analysis_report_consumption.timestamp'),
            data: this.getAmountContractByYears(3, this.consumptionRequest.fromDate, this.consumptionRequest.toDate, dataYear.filter(x => x.service === 'SERVICE_MONEY_TIMESTAMP')),
            yAxis: 1,
            color: this.color_yellow,
          }
        ]);

        // Nếu là người dùng không chứng thực thì bỏ line "Chứng thực"; chưa mua SMS thì bỏ line SMS
        this.trimConsumptionSeries();

        switch (option) {
          case 1:
            this.ConsumptionLineChart(this.seriesConsumptionDay, this.categoriesConsumptionDay, option);
            break;
          case 2:
            this.ConsumptionLineChart(this.seriesConsumptionWeek, this.categoriesConsumptionWeek, option);
            break;
          case 3:
            this.ConsumptionLineChart(this.seriesConsumptionMonth, this.categoriesConsumptionMonth, option);
            break;
          case 4:
            this.ConsumptionLineChart(this.seriesConsumptionQuarter, this.categoriesConsumptionQuarter, option);
            break;
          case 5:
            this.ConsumptionLineChart(this.seriesConsumptionYear, this.categoriesConsumptionYear, option);
            break;
          default:
            return;
        }
      }
    );
  }

  trimConsumptionSeries() {
    // Nếu là người dùng không chứng thực thì bỏ line "Chứng thực"
    if (this.isNotAttestedUser) {
      this.seriesConsumptionDay = this.seriesConsumptionDay.splice(0, 2);
      this.seriesConsumptionWeek = this.seriesConsumptionWeek.splice(0, 2);
      this.seriesConsumptionMonth = this.seriesConsumptionMonth.splice(0, 2);
      this.seriesConsumptionQuarter = this.seriesConsumptionQuarter.splice(0, 2);
      this.seriesConsumptionYear = this.seriesConsumptionYear.splice(0, 2);
    }

    // chua mua dich vu
    if (!this.isBuySmsBccs) {
      this.seriesConsumptionDay = this.seriesConsumptionDay.slice(0, 1);
      this.seriesConsumptionWeek = this.seriesConsumptionWeek.slice(0, 1);
      this.seriesConsumptionMonth = this.seriesConsumptionMonth.slice(0, 1);
      this.seriesConsumptionQuarter = this.seriesConsumptionQuarter.slice(0, 1);
      this.seriesConsumptionYear = this.seriesConsumptionYear.slice(0, 1);
    }
  }

  getSeriesByOption(option: number) {
    switch (option) {
      case 1: return this.seriesConsumptionDay;
      case 2: return this.seriesConsumptionWeek;
      case 3: return this.seriesConsumptionMonth;
      case 4: return this.seriesConsumptionQuarter;
      case 5: return this.seriesConsumptionYear;
      default: return this.seriesConsumptionDay;
    }
  }

  getCategoriesByOption(option: number) {
    switch (option) {
      case 1: return this.categoriesConsumptionDay;
      case 2: return this.categoriesConsumptionWeek;
      case 3: return this.categoriesConsumptionMonth;
      case 4: return this.categoriesConsumptionQuarter;
      case 5: return this.categoriesConsumptionYear;
      default: return this.categoriesConsumptionDay;
    }
  }

  onChangeSelect(optionsSelect) {
    this.resetDateForChangeSelect(optionsSelect);
    this.getDataConsumptionHistory(optionsSelect);
    this.getDataCountNumberDocument();
  }

  resetDateForChangeSelect(option) {
    this.isShowWarningConsumptionFromDate = false;
    this.isShowWarningConsumptionToDate = false;
    const currentCreatedTimeFromInput = moment(this.defaultModelCreateTime.createdTimeFrom).format('YYYY-MM-DD');
    const currentCreatedTimeToInput = moment(this.defaultModelCreateTime.createdTimeTo).format('YYYY-MM-DD');

    if (option === 1) {          // day
      const maxAllowCreatedTimeTo = moment(currentCreatedTimeFromInput).add(30, 'd').format('YYYY-MM-DD');
      if (!moment(currentCreatedTimeToInput).isBetween(moment(currentCreatedTimeFromInput), moment(maxAllowCreatedTimeTo), undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo;
      }
    }

    if (option === 2) {          // week
      const maxAllowCreatedTimeTo = moment(currentCreatedTimeFromInput).add(10, 'weeks').subtract(1, 'd').format('YYYY-MM-DD');
      if (!moment(currentCreatedTimeToInput).isBetween(moment(currentCreatedTimeFromInput), moment(maxAllowCreatedTimeTo), undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo;
      }
    }

    if (option === 3) {          // month
      const maxAllowCreatedTimeTo = moment(currentCreatedTimeFromInput).add(12, 'months').subtract(1, 'd').format('YYYY-MM-DD');
      if (!moment(currentCreatedTimeToInput).isBetween(moment(currentCreatedTimeFromInput), moment(maxAllowCreatedTimeTo), undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo;
      }
    }

    if (option === 4) {          // quarter
      const maxAllowCreatedTimeTo = moment(currentCreatedTimeFromInput).add(10, 'quarters').subtract(1, 'd').format('YYYY-MM-DD');
      if (!moment(currentCreatedTimeToInput).isBetween(moment(currentCreatedTimeFromInput), moment(maxAllowCreatedTimeTo), undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo;
      }
    }

    if (option === 5) {          // year
      const maxAllowCreatedTimeTo = moment(currentCreatedTimeFromInput).add(10, 'years').subtract(1, 'd').format('YYYY-MM-DD');
      if (!moment(currentCreatedTimeToInput).isBetween(moment(currentCreatedTimeFromInput), moment(maxAllowCreatedTimeTo), undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo;
      }
    }

    this.consumptionFormGroup = this.formBuilder.group({
      fromDate: [moment(this.defaultModelCreateTime.createdTimeFrom).format('YYYY-MM-DD'), [Validators.required]],
      toDate: [moment(this.defaultModelCreateTime.createdTimeTo).format('YYYY-MM-DD'), [Validators.required]],
    });
  }

  changeDatePickerFromDate(type: string, event: MatDatepickerInputEvent<Date>) {
    // console.log("event: ", event.value);
    // this.inValidFromDateFormat = '';
    // this.inValideFormDateEmpty = '';
    this.isShowWarningConsumptionFromDate = false;
    this.isShowWarningConsumptionToDate = false;
    if (event.value === null) {
      return;
      // if (this.inputFromDate.nativeElement.value.length === 0) {
      //   this.inValideFormDateEmpty = this.message.getMessage('validation.empty_of_date_consumption');
      // } else {
      //   this.inValidFromDateFormat = this.message.getMessage('validation.format_of_date_consumption');
      // }
      // this.isValidFormDate = false;
    } else {
      // this.isValidFormDate = true;
      this.defaultModelCreateTime.createdTimeFrom = moment(event.value).format('YYYY-MM-DD');

      // re-calculate value of timeTo
      if (!moment(this.defaultModelCreateTime.createdTimeTo).isSameOrAfter(moment(event.value), undefined)) {
        this.defaultModelCreateTime.createdTimeTo = moment(event.value).format('YYYY-MM-DD');
      }
      const currentCreatedTimeToInput = moment(this.defaultModelCreateTime.createdTimeTo);

      // day
      if (this.optionsSelect === 1) {
        const maxAllowCreatedTimeTo = moment(event.value).add(30, 'd');
        if (!currentCreatedTimeToInput.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo.format('YYYY-MM-DD');
          this.isShowWarningConsumptionFromDate = true;
        }
      }

      // week
      if (this.optionsSelect === 2) {
        const maxAllowCreatedTimeTo = moment(event.value).add(10, 'weeks').subtract(1, 'd');
        if (!currentCreatedTimeToInput.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo.format('YYYY-MM-DD');
          this.isShowWarningConsumptionFromDate = true;
        }
      }

      // month
      if (this.optionsSelect === 3) {
        const maxAllowCreatedTimeTo = moment(event.value).add(12, 'months').subtract(1, 'd');
        if (!currentCreatedTimeToInput.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo.format('YYYY-MM-DD');
          this.isShowWarningConsumptionFromDate = true;
        }
      }

      // quarter
      if (this.optionsSelect === 4) {
        const maxAllowCreatedTimeTo = moment(event.value).add(10, 'quarters').subtract(1, 'd');
        if (!currentCreatedTimeToInput.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo.format('YYYY-MM-DD');
          this.isShowWarningConsumptionFromDate = true;
        }
      }

      // year
      if (this.optionsSelect === 5) {
        const maxAllowCreatedTimeTo = moment(event.value).add(10, 'years').subtract(1, 'd');
        if (!currentCreatedTimeToInput.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo.format('YYYY-MM-DD');
          this.isShowWarningConsumptionFromDate = true;
        }
      }

      this.consumptionFormGroup = this.formBuilder.group({
        fromDate: [moment(this.defaultModelCreateTime.createdTimeFrom).format('YYYY-MM-DD'), [Validators.required]],
        toDate: [moment(this.defaultModelCreateTime.createdTimeTo).format('YYYY-MM-DD'), [Validators.required]],
      });

      this.getDataConsumptionHistory(this.optionsSelect);
      this.getDataCountNumberDocument();
    }


    // if (event.value) {
    //   this.consumptionFormGroup = this.formBuilder.group({
    //     fromDate: [moment(this.defaultModelCreateTime.createdTimeFrom).format('YYYY-MM-DD'), [Validators.required, this.myValidatorFromDate]],
    //     toDate: [moment(this.defaultModelCreateTime.createdTimeTo).format('YYYY-MM-DD'), [Validators.required, this.myValidatorFromDate]],
    //   });
    //   this.getDataConsumptionHistory(this.optionsSelect);
    // }
  }

  changeDatePickerToDate(type: string, event: MatDatepickerInputEvent<Date>) {
    this.isShowWarningConsumptionToDate = false;
    this.isShowWarningConsumptionFromDate = false;
    if (event.value === null) {
      return;
    } else {
      this.defaultModelCreateTime.createdTimeTo = moment(event.value).format('YYYY-MM-DD');

      // re-calculate value of timeFrom
      if (!moment(this.defaultModelCreateTime.createdTimeFrom).isSameOrBefore(moment(event.value), undefined)) {
        this.defaultModelCreateTime.createdTimeFrom = moment(event.value).format('YYYY-MM-DD');
      }
      const currentCreatedTimeFromInput = moment(this.defaultModelCreateTime.createdTimeFrom);

      // day
      if (this.optionsSelect === 1) {
        const minAllowCreatedTimeFrom = moment(event.value).subtract(30, 'd');
        if (!currentCreatedTimeFromInput.isBetween(minAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeFrom = minAllowCreatedTimeFrom.format('YYYY-MM-DD');
          this.isShowWarningConsumptionToDate = true;
        }
      }

      // week
      if (this.optionsSelect === 2) {
        const minAllowCreatedTimeFrom = moment(event.value).subtract(10, 'weeks').add(1, 'd');
        if (!currentCreatedTimeFromInput.isBetween(minAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeFrom = minAllowCreatedTimeFrom.format('YYYY-MM-DD');
          this.isShowWarningConsumptionToDate = true;
        }
      }

      // month
      if (this.optionsSelect === 3) {
        const minAllowCreatedTimeFrom = moment(event.value).subtract(12, 'months').add(1, 'd');
        if (!currentCreatedTimeFromInput.isBetween(minAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeFrom = minAllowCreatedTimeFrom.format('YYYY-MM-DD');
          this.isShowWarningConsumptionToDate = true;
        }
      }

      // quarter
      if (this.optionsSelect === 4) {
        const minAllowCreatedTimeFrom = moment(event.value).subtract(10, 'quarters').add(1, 'd');
        if (!currentCreatedTimeFromInput.isBetween(minAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeFrom = minAllowCreatedTimeFrom.format('YYYY-MM-DD');
          this.isShowWarningConsumptionToDate = true;
        }
      }

      // year
      if (this.optionsSelect === 5) {
        const minAllowCreatedTimeFrom = moment(event.value).subtract(10, 'years').add(1, 'd');
        if (!currentCreatedTimeFromInput.isBetween(minAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeFrom = minAllowCreatedTimeFrom.format('YYYY-MM-DD');
          this.isShowWarningConsumptionToDate = true;
        }
      }

      this.consumptionFormGroup = this.formBuilder.group({
        fromDate: [moment(this.defaultModelCreateTime.createdTimeFrom).format('YYYY-MM-DD'), [Validators.required]],
        toDate: [moment(this.defaultModelCreateTime.createdTimeTo).format('YYYY-MM-DD'), [Validators.required]],
      });
      this.getDataConsumptionHistory(this.optionsSelect);
      this.getDataCountNumberDocument();
    }
  }

  keyupEnterSelected() {
    setTimeout(() => {
      this.getDataConsumptionHistory(this.optionsSelect);
      this.getDataCountNumberDocument();
    }, 200);
  }

  toStringQuarter(time: moment.Moment): string {
    const quarter = time.quarter();
    const year = time.year();
    return `Q${quarter}/${year}`;
  }

  getAmountContractByDays(type, createdTimeFrom, createdTimeTo, datas) {
    const resultData = [];
    createdTimeFrom = this.datepipe.transform(createdTimeFrom, 'yyyy-MM-dd');
    createdTimeTo = this.datepipe.transform(createdTimeTo, 'yyyy-MM-dd');

    // add thêm những ngày còn thiếu trong range date.
    const currentArrayList = this.handlerAddDayForSelectedTime(type, createdTimeFrom, createdTimeTo, datas);

    // kiểm tra nếu đã có ngày đó thì update ko thì thêm fill thêm vào mảng.
    const newArrayBeforeFillDates = this.fillDates(type, currentArrayList);

    if (newArrayBeforeFillDates !== null && newArrayBeforeFillDates !== undefined && newArrayBeforeFillDates.length > 0) {
      newArrayBeforeFillDates.forEach(x => {
        this.categoriesConsumptionDay.push(this.datepipe.transform(x.dayWeekMonth, 'dd/MM'));
      });

      newArrayBeforeFillDates.forEach(x => {
        // Lấy data theo loại
        type === 1 ? resultData.push(x.contract_quantity) : resultData.push(x.sms_money_quantity);
        if (this.maxContractChart < x.contract_quantity) {
          this.maxContractChart = x.contract_quantity;
        }
        if (this.maxSMSChart < x.sms_money_quantity) {
          this.maxSMSChart = x.sms_money_quantity;
        }
      });
    }
    return resultData;
  }

  getAmountContractByMonths(type, createdTimeFrom, createdTimeTo, datas) {
    const resultData = [];
    const resultDataMonths = [];
    const startDate = moment(createdTimeFrom, 'YYYY/MM/DD');
    const endDate = moment(createdTimeTo, 'YYYY/MM/DD');

    // Lấy ra các tháng trong khoảng thời gian trên.
    while (endDate > startDate || startDate.format('M') === endDate.format('M')) {
      resultDataMonths.push(startDate.format('MM/YYYY'));
      startDate.add(1, 'month');
    }
    // console.log("resultDataMonths: ", resultDataMonths);

    this.categoriesConsumptionMonth = (resultDataMonths !== null && resultDataMonths !== undefined && resultDataMonths.length > 0) ? resultDataMonths : [];

    // add thêm những tháng còn thiếu trong range date.
    const newArrayAfterFillMonths = this.fillMonths(type, datas, resultDataMonths);
    // console.log("fill data of month: ", newArrayAfterFillMonths);

    if (newArrayAfterFillMonths !== null && newArrayAfterFillMonths !== undefined && newArrayAfterFillMonths.length > 0) {
      newArrayAfterFillMonths.forEach(x => {
        type === 1 ? resultData.push(x.contract_quantity) : resultData.push(x.sms_money_quantity);
        // switch(type){
        //   case 1: {
        //     resultData.push(x.contract_quantity);
        //     break;
        //   }
        //   case 2: {
        //     resultData.push(x.sms_money_quantity);
        //     break;
        //   }
        //   case 3: {
        //     resultData.push(x.sms_money_quantity);
        //     break;
        //   }
        // }
        // if(this.maxSMSChartMonth < x.timestamp_money_quantity){
        //   this.maxSMSChartMonth = x.timestamp_money_quantity
        if (this.maxContractChartMonth < x.contract_quantity) {
          this.maxContractChartMonth = x.contract_quantity;
        }
        if (this.maxSMSChartMonth < x.sms_money_quantity) {
          this.maxSMSChartMonth = x.sms_money_quantity;
        }
      });
    }

    return resultData;
  }

  getAmountContractByYears(type, createdTimeFrom, createdTimeTo, datas) {
    const resultData = [];
    const resultDataYear = [];
    const startDate = moment(createdTimeFrom, 'YYYY/MM/DD');
    const endDate = moment(createdTimeTo, 'YYYY/MM/DD');

    // Lấy ra các tháng trong khoảng thời gian trên.
    while (endDate > startDate || startDate.format('YYYY') === endDate.format('YYYY')) {
      resultDataYear.push(startDate.format('YYYY'));
      startDate.add(1, 'year');
    }
    // console.log("resultDataMonths: ", resultDataMonths);

    this.categoriesConsumptionYear = (resultDataYear !== null && resultDataYear !== undefined && resultDataYear.length > 0) ? resultDataYear : [];

    // add thêm những tháng còn thiếu trong range date.
    const newArrayAfterFillMonths = this.fillMonths(type, datas, resultDataYear);
    // console.log("fill data of month: ", newArrayAfterFillMonths);

    if (newArrayAfterFillMonths !== null && newArrayAfterFillMonths !== undefined && newArrayAfterFillMonths.length > 0) {
      newArrayAfterFillMonths.forEach(x => {
        type === 1 ? resultData.push(x.contract_quantity) : resultData.push(x.sms_money_quantity);

        if (this.maxContractChartYear < x.contract_quantity) {
          this.maxContractChartYear = x.contract_quantity;
        }
        if (this.maxSMSChartYear < x.sms_money_quantity) {
          this.maxSMSChartYear = x.sms_money_quantity;
        }
      });
    }

    return resultData;
  }

  getAmountContractByWeeks(type, createdTimeFrom, createdTimeTo, datas) {
    const resultData = [];

    // add thêm những tuần còn thiếu trong range date.
    const getWeeksOfYears = this.splitTimeToWeek(createdTimeFrom, createdTimeTo);
    // console.log("getWeeksOfYears: ", getWeeksOfYears);
    getWeeksOfYears.forEach(x => {
      this.categoriesConsumptionWeek.push(x.rangeDate);
    });

    // kiểm tra nếu đã có Tuần đó thì update ko thì thêm fill thêm vào mảng.
    const newArrayAfterFillWeeks = this.fillWeeks(type, datas, getWeeksOfYears);

    if (newArrayAfterFillWeeks !== null && newArrayAfterFillWeeks !== undefined && newArrayAfterFillWeeks.length > 0) {
      newArrayAfterFillWeeks.forEach(x => {
        // Lấy data theo loại
        type === 1 ? resultData.push(x.contract_quantity) : resultData.push(x.sms_money_quantity);

        if (this.maxContractChartWeek < x.contract_quantity) {
          this.maxContractChartWeek = x.contract_quantity;
        }
        if (this.maxSMSChartWeek < x.sms_money_quantity) {
          this.maxSMSChartWeek = x.sms_money_quantity;
        }
      });
    }

    return resultData;
  }

  getAmountContractByQuarters(type, createdTimeFrom, createdTimeTo, datas) {
    const resultData = [];
    let resultDataQuarter = [];
    const startDate = moment(createdTimeFrom, 'YYYY/MM/DD');
    const endDate = moment(createdTimeTo, 'YYYY/MM/DD');

    // Lấy ra các quý trong khoảng thời gian trên.
    while (endDate > startDate || this.toStringQuarter(startDate) === this.toStringQuarter(endDate)) {
      resultDataQuarter.push(this.toStringQuarter(startDate));
      startDate.add(1, 'month');
    }
    resultDataQuarter = [...new Set(resultDataQuarter)];
    this.categoriesConsumptionQuarter = resultDataQuarter.length > 0 ? resultDataQuarter : [];
    // kiểm tra nếu đã có Qúy đó thì update ko thì thêm fill thêm vào mảng.
    const newArrayAfterFillQuarter = this.fillQuarters(type, datas, resultDataQuarter);

    if (newArrayAfterFillQuarter !== null && newArrayAfterFillQuarter !== undefined && newArrayAfterFillQuarter.length > 0) {
      newArrayAfterFillQuarter.forEach(x => {
        // Lấy data theo loại
        type === 1 ? resultData.push(x.contract_quantity) : resultData.push(x.sms_money_quantity);

        if (this.maxContractChartQuarter < x.contract_quantity) {
          this.maxContractChartQuarter = x.contract_quantity;
        }
        if (this.maxSMSChartQuarter < x.sms_money_quantity) {
          this.maxSMSChartQuarter = x.sms_money_quantity;
        }
      });
    }

    return resultData;
  }

  handlerAddDayForSelectedTime(type, createdTimeFrom, createdTimeTo, datas) {
    const findIndexCreatedTimeFrom = datas.findIndex(x => x.dayWeekMonth == createdTimeFrom);
    if (findIndexCreatedTimeFrom === -1) {
      // chưa có thì add thêm ngày đó vào đầu.
      const obj1 = {
        contract_quantity: 0,
        sms_money_quantity: 0,
        service: (type == 1 ? 'CONTRACT' : type == 2 ? 'SMS' : 'SERVICE_MONEY_TIMESTAMP'),
        dayWeekMonth: this.datepipe.transform(createdTimeFrom, 'yyyy-MM-dd'),
        created_time: (createdTimeFrom),
      };

      // add vào đầu của mảng.
      datas.unshift(obj1);
    }

    const findIndexCreatedTo = datas.findIndex(x => x.dayWeekMonth == createdTimeTo);
    if (findIndexCreatedTo === -1) {
      // chưa có thì add thêm ngày đó vào cuối.
      const obj2 = {
        contract_quantity: 0,
        sms_money_quantity: 0,
        service: (type == 1 ? 'CONTRACT' : type == 2 ? 'SMS' : 'SERVICE_MONEY_TIMESTAMP'),
        dayWeekMonth: this.datepipe.transform(createdTimeTo, 'yyyy-MM-dd'),
        created_time: createdTimeTo,
      };

      // add vào cuối của mảng.
      datas.push(obj2);
    }
    return datas;
  }

  fillWeeks(type, datas, getWeeksOfYears) {
    const result = [];

    getWeeksOfYears.forEach(w => {
      const findItemDataOfWeek = datas.filter(x => Number(x.dayWeekMonth) === w.week);
      if (findItemDataOfWeek.length > 0) {
        const objWeek = {
          contract_quantity: findItemDataOfWeek[0].contract_quantity,
          sms_money_quantity: findItemDataOfWeek[0].sms_money_quantity,
          service: findItemDataOfWeek[0].service,
          dayWeekMonth: findItemDataOfWeek[0].dayWeekMonth,
          created_time: findItemDataOfWeek[0].created_time,
          rangeDate: w.rangeDate
        };
        result.push(objWeek);
      } else {
        const objWeek = {
          contract_quantity: 0,
          sms_money_quantity: 0,
          service: (type === 1 ? 'CONTRACT' : type === 2 ? 'SMS' : 'SERVICE_MONEY_TIMESTAMP'),
          dayWeekMonth: w.week + '',
          created_time: '',
          rangeDate: w.rangeDate
        };
        result.push(objWeek);
      }

      // datas = datas.sort(this.dynamicSort("dayWeekMonth", "asc"));//desc
    });

    return result;
  }

  fillMonths(type, datas, resultDataMonths) {
    const result = [];
    resultDataMonths.forEach(m => {
      const findItemDataOfMonth = datas.filter(x => x.dayWeekMonth === m);
      if (findItemDataOfMonth.length > 0) {
        const objMonth = {
          contract_quantity: findItemDataOfMonth[0].contract_quantity || 0,
          sms_money_quantity: findItemDataOfMonth[0].sms_money_quantity || 0,
          service: findItemDataOfMonth[0].service || '',
          dayWeekMonth: findItemDataOfMonth[0].dayWeekMonth || '',
          created_time: findItemDataOfMonth[0].created_time || '',
        };
        result.push(objMonth);
      } else {
        const objMonth = {
          contract_quantity: 0,
          sms_money_quantity: 0,
          service: (type === 1 ? 'CONTRACT' : type === 2 ? 'SMS' : 'SERVICE_MONEY_TIMESTAMP'),
          dayWeekMonth: m,
          created_time: '',
        };
        result.push(objMonth);
      }

      // datas = datas.sort(this.dynamicSortMonth("dayWeekMonth", "asc"));//desc
    });

    return result;
  }

  fillQuarters(type: number, datas: any[], resultDataQuarters: string[]) {
    const result = [];
    resultDataQuarters.forEach(quarter => {
      const findItemDataOfQuarter = datas.find(x => {
        const stringQuarter = this.toStringQuarter(moment(x.created_time));
        return stringQuarter === quarter;
      });
      if (findItemDataOfQuarter) {
        const objMonth = {
          contract_quantity: findItemDataOfQuarter.contract_quantity || 0,
          sms_money_quantity: findItemDataOfQuarter.sms_money_quantity || 0,
          service: findItemDataOfQuarter.service || '',
          dayWeekMonth: findItemDataOfQuarter.dayWeekMonth || '',
          created_time: findItemDataOfQuarter.created_time || '',
        };
        result.push(objMonth);
      } else {
        const objMonth = {
          contract_quantity: 0,
          sms_money_quantity: 0,
          service: (type === 1 ? 'CONTRACT' : type === 2 ? 'SMS' : 'SERVICE_MONEY_TIMESTAMP'),
          dayWeekMonth: quarter,
          created_time: '',
        };
        result.push(objMonth);
      }
    });

    return result;
  }

  dynamicSortMonth(property, order) {
    let sort_order = 1;
    if (order === 'desc') {
      sort_order = -1;
    }
    return function (a, b) {
      if (Number(a[property].substr(0, a[property].indexOf('/'))) < Number(b[property].substr(0, b[property].indexOf('/')))) {
        return -1 * sort_order;
      } else if (Number(a[property].substr(0, a[property].indexOf('/'))) > Number(b[property].substr(0, b[property].indexOf('/')))) {
        return 1 * sort_order;
      } else {
        return 0 * sort_order;
      }
    };
  }

  fillDates(type, datas) {
    const filledInDates = datas.reduce((newArray, currentModel, index, originalArray) => {
      const nextModel = originalArray[index + 1];

      if (nextModel) {
        const currentDate = moment(currentModel.dayWeekMonth);
        const daysBetween = moment(nextModel.dayWeekMonth).diff(currentDate, 'days');

        const fillerDates = Array.from({ length: daysBetween - 1 }, (value, dayIndex) => {
          return {
            contract_quantity: 0,
            sms_money_quantity: 0,
            service: type == 1 ? 'CONTRACT' : type == 2 ? 'SMS' : 'SERVICE_MONEY_TIMESTAMP',
            dayWeekMonth: moment(currentDate).add(dayIndex + 1, 'days').format('YYYY-MM-DD'),
            created_time: moment(currentDate).add(dayIndex + 1, 'days').toISOString()
          };
        });

        newArray.push(currentModel, ...fillerDates);
      } else {
        newArray.push(currentModel);
      }

      return newArray;
    }, []);

    return filledInDates;
  }

  splitTimeToWeek(startDate, endDate) {
    const result = [];
    startDate = new Date(startDate); // new Date('2020-10-01');
    endDate = new Date(endDate); // new Date('2020-10-31');
    const tempDate = new Date(startDate);

    // kiểm tra nếu khoảng thời gian là 1 ngày thì sẽ lấy ra 1 tuần:
    if (moment(startDate).format('DD-MM-YYYY') === moment(endDate).format('DD-MM-YYYY')) {
      const object = {
        startDay: this.datepipe.transform(startDate, 'dd/MM'),
        endDay: this.datepipe.transform(startDate, 'dd/MM'),
        rangeDate: this.datepipe.transform(startDate, 'dd/MM') + ' - ' + this.datepipe.transform(startDate, 'dd/MM'),
        week: moment(startDate).isoWeek(),
        year: moment(startDate).year(),
      };
      result.push(object);
    } else { // thực hiện lấy theo các khoảng tuần
      // get current date
      const first = tempDate.getDate() - tempDate.getDay() + 1; // First day is the  day of the month - the day of the week
      let firstDayOfWeek = new Date(tempDate.setDate(first));
      let lastDayOfWeek = new Date(tempDate.setDate(tempDate.getDate() + 6));
      // nếu ngày bắt đầu nhỏ hơn ngày đầu tiên của tuần thì lấy thêm 1 tuần của ngày đó:
      if (startDate < firstDayOfWeek) {
        const object = {
          startDay: this.datepipe.transform(startDate, 'dd/MM'),
          endDay: this.datepipe.transform(startDate, 'dd/MM'),
          rangeDate: this.datepipe.transform(startDate, 'dd/MM') + ' - ' + this.datepipe.transform(startDate, 'dd/MM'),
          week: moment(startDate).isoWeek(),
          year: moment(startDate).year(),
        };
        result.push(object);
      }

      if (lastDayOfWeek >= endDate) {
        lastDayOfWeek = new Date(endDate);
        if (firstDayOfWeek <= startDate) {
          firstDayOfWeek = new Date(startDate);
        }

        const object = {
          startDay: this.datepipe.transform(firstDayOfWeek, 'dd/MM'),
          endDay: this.datepipe.transform(lastDayOfWeek, 'dd/MM'),
          rangeDate: this.datepipe.transform(firstDayOfWeek, 'dd/MM') + ' - ' + this.datepipe.transform(lastDayOfWeek, 'dd/MM'),
          week: moment(firstDayOfWeek).isoWeek(),
          year: moment(firstDayOfWeek).year(),

        };
        result.push(object);
        return result;
      }

      while (lastDayOfWeek <= endDate) {
        if (firstDayOfWeek <= startDate) {
          firstDayOfWeek = new Date(startDate);
        }
        const object = {
          startDay: this.datepipe.transform(firstDayOfWeek, 'dd/MM'),
          endDay: this.datepipe.transform(lastDayOfWeek, 'dd/MM'),
          rangeDate: this.datepipe.transform(firstDayOfWeek, 'dd/MM') + ' - ' + this.datepipe.transform(lastDayOfWeek, 'dd/MM'),
          week: moment(firstDayOfWeek).isoWeek(),
          year: moment(firstDayOfWeek).year()
        };
        result.push(object);

        // re-calculate dates
        firstDayOfWeek = new Date(tempDate.setDate(lastDayOfWeek.getDate() + 1));
        lastDayOfWeek = new Date(tempDate.setDate(tempDate.getDate() + 6));
      }

      if (firstDayOfWeek <= endDate) {
        const object = {
          startDay: this.datepipe.transform(firstDayOfWeek, 'dd/MM'),
          endDay: this.datepipe.transform(endDate, 'dd/MM'),
          rangeDate: this.datepipe.transform(firstDayOfWeek, 'dd/MM') + ' - ' + this.datepipe.transform(endDate, 'dd/MM'),
          week: moment(firstDayOfWeek).isoWeek(),
          year: moment(firstDayOfWeek).year(),
        };
        result.push(object);
      }
    }

    return result;
  }

  //// ------------------------------------***HIGH CHARTS***------------------------------------////

  EnterprisePieChart(data, colors, langNodata) {
    this.chartOptionsEnterprise = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        events: {
        }
      },
      legend: {
        margin: 20,
        padding: 0,
        // verticalAlign: 'center',
        // layout: 'vertical',
        // align: 'bottom',
        itemStyle: {
          fontSize: '12.3px',
          fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
        }
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      tooltip: {
        backgroundColor: '#FFFFFF',
        // pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
        formatter() {
          return '<span style="color:' + this.point.color + '">\u25CF </span>' + '<b>' + this.point.name + '</b>';
        },
        style: {
          fontSize: '14px',
          color: '#1D243E',
          fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
        }
      },
      plotOptions: {
        pie: {
          size: '90%',
          shadow: false,
          slicedOffset: 5,
          allowPointSelect: true,
          cursor: 'pointer',
          point: {
            events: {
              click() {
                this.options.router.navigate([this.options.url], {
                  queryParams: {
                    status: this.options.status,
                    createdTimeFrom: this.options.fromDate,
                    createdTimeTo: this.options.toDate,
                  }
                });
                // return location.href = this.options.url;
                // return window.open(this.options.url + '/?status=' + this.options.value, '_blank');
              }
            }
          },
          dataLabels: {
            enabled: true,
            // format: '{point.name}: {point.percentage:.1f}%',
            format: '{point.percentage:.1f}%',
            style: {
              fontSize: '14px',
              fontWeight: 'normal',
              color: '#1D243E',
              // fontFamily: '\'Lato\', sans-serif',
              fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
            }
          },
          showInLegend: true
        },
      },
      series: [{
        name: 'Tổng',
        innerSize: '40%',
        data,
        states: {
          inactive: {
            opacity: 1
          }
        },
        // colorByPoint: true,
        colors,
      }],
    };
  }

  BCTPieChart(data, colors, langNodata) {
    this.chartOptionsBCT = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        events: {
        }
      },
      legend: {
        margin: 20,
        padding: 0,
        // verticalAlign: 'center',
        // layout: 'vertical',
        // align: 'bottom',
        itemStyle: {
          fontSize: '12.3px',
          fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
        }
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      tooltip: {
        backgroundColor: '#FFFFFF',
        // pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
        formatter() {
          return '<span style="color:' + this.point.color + '">\u25CF </span>' + '<b>' + this.point.name + '</b>';
        },
        style: {
          fontSize: '14px',
          color: '#1D243E',
          fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
        }
      },
      plotOptions: {
        pie: {
          size: '90%',
          shadow: false,
          slicedOffset: 5,
          allowPointSelect: true,
          cursor: 'pointer',
          point: {
            events: {
              click() {
                this.options.router.navigate([this.options.url], {
                  queryParams: {
                    bctConfirmStatus: this.options.BCTConfirmStatus,
                    createdTimeFrom: this.options.fromDate,
                    createdTimeTo: this.options.toDate,
                  }
                });
                // return location.href = this.options.url;
                // return window.open(this.options.url + '/?status=' + this.options.value, '_blank');
              }
            }
          },
          dataLabels: {
            enabled: true,
            // format: '{point.name}: {point.percentage:.1f}%',
            format: '{point.percentage:.1f}%',
            style: {
              fontSize: '14px',
              fontWeight: 'normal',
              color: '#1D243E',
              // fontFamily: '\'Lato\', sans-serif',
              fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
            }
          },
          showInLegend: true
        },
      },
      series: [{
        name: 'Tổng',
        innerSize: '40%',
        data,
        states: {
          inactive: {
            opacity: 1
          }
        },
        // colorByPoint: true,
        colors,
      }],
    };
  }

  UserColumnChart(data, langNodata) {
    this.chartOptionsUser = {
      chart: {
        type: 'column',
        // renderTo: 'container',
        // margin: [50, 50, 100, 80]
        // events: {
        //   load: function () {
        //     if (data[0].y == 0 && data[1].y == 0 && data[2].y == 0 && data[3].y == 0 && data[4].y == 0) {
        //       $("#userColumnChart").empty();
        //       $("#userColumnChart").append('<div class="no-data-chart"><img alt="time" src="./assets/images/no-data-chart.svg" width="100" height="100"><span>' + langNodata + '</span></div>');
        //     }
        //   }
        // }
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      subtitle: {
        text: ''
      },
      accessibility: {
        announceNewData: {
          enabled: true
        }
      },
      xAxis: {
        type: 'category',
        labels: {
          rotation: -45,
          style: {
            fontSize: '12px',
            fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
            color: 'black'
          }
        }
      },
      yAxis: {
        title: {
          text: ''  // countWeek() {
          //   let date = new Date();
          //   let year = date.getFullYear(), month = date.getMonth();
          //   const firstOfMonth = new Date(year, month - 1, 1);
          //   const lastOfMonth = new Date(year, month, 0);
          //   const used = firstOfMonth.getDay() + lastOfMonth.getDate();
          //   const count = Math.ceil(used / 7);
          //   return count
          // }
        },
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
            color: 'black'
          }
        }

      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            crop: false,
            overflow: 'none',
            format: '{point.y}',
            style: {
              color: 'black',
              fontWeight: 'normal',
              fontSize: '14px',
              fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
            }
          },
          pointWidth: 50,
          point: {
            events: {
              click() {
                this.options.router.navigate([this.options.url], {
                  queryParams: {
                    status: this.options.status
                  }
                });
                // return location.href = this.options.url;
              }
            }
          },
          cursor: 'pointer',
          states: {
            hover: {
              color: '#0065FF' // darken
            }
          }
        }
      },
      tooltip: {
        shared: true,
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>',
        style: {
          fontSize: '13px',
          color: 'black',
        }
      },
      series: [
        {
          name: '',
          showInLegend: false,
          data,
          // colorByPoint: true,
          color: '#3473B5',
          fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
        }
      ],
      exporting: {
        // sourceWidth: 610,
        // sourceHeight: 390,
      },
      noData: {
        style: {
          fontWeight: 'bold',
          fontSize: '14px',
          color: '#303030',
        }
      }
    };
  }

  UserHandleColumnChart(data, langNodata) {
    this.chartOptionsUserHandle = {
      chart: {
        type: 'column',
        // renderTo: 'container',
        // margin: [50, 50, 100, 80]
        // events: {
        //   load: function () {
        //     if (data[0].y == 0 && data[1].y == 0 && data[2].y == 0) {
        //       $("#user-handle").empty();
        //       $("#user-handle").append('<div class="no-data-chart"><img alt="time" src="./assets/images/no-data-chart.svg" width="100" height="100"><span>' + langNodata + '</span></div>');
        //     }
        //   }
        // }
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      subtitle: {
        text: ''
      },
      accessibility: {
        announceNewData: {
          enabled: true
        }
      },
      xAxis: {
        type: 'category',
        labels: {
          rotation: -45,
          style: {
            fontSize: '12px',
            fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
            color: 'black'
          }
        }
      },
      yAxis: {
        title: {
          text: ''
        },
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
            color: 'black'
          }
        }

      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            crop: false,
            overflow: 'none',
            format: '{point.y}',
            style: {
              color: 'black',
              fontWeight: 'normal',
              fontSize: '14px',
              fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
            }
          },
          pointWidth: 50,
          point: {
            events: {
              click() {
                this.options.router.navigate([this.options.url], { state: { key: 'analysis-report-enterprise' } });
                // return location.href = this.options.url;
                // return window.open(this.options.url + '/?status=' + this.options.value, '_blank');
              }
            }
          },
          cursor: 'pointer',
          states: {
            hover: {
              color: '#0065FF' // darken
            }
          }
        }
      },
      tooltip: {
        shared: true,
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>',
        style: {
          fontSize: '13px',
          color: 'black',
        }
      },
      series: [
        {
          name: '',
          showInLegend: false,
          data,
          // colorByPoint: true,
          color: '#3473B5',
          fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
        }
      ],
      exporting: {
        // sourceWidth: 610,
        // sourceHeight: 390,
      },
      noData: {
        style: {
          fontWeight: 'bold',
          fontSize: '14px',
          color: '#303030',
        }
      }
    };
  }

  // Line chart
  ConsumptionLineChart(data, categories, option) {
    // language
    const dayLang = this.message.getMessage('analysis.analysis_report_consumption.options.day');
    const dayForLang = this.message.getMessage('analysis.analysis_report_consumption.options.from_date');
    const monthLang = this.message.getMessage('analysis.analysis_report_consumption.options.month');
    const monthForLang = this.message.getMessage('analysis.analysis_report_consumption.options.from_month');
    const yearLang = this.message.getMessage('analysis.analysis_report_consumption.options.year');
    const tooltips = {
      shared: true,
      backgroundColor: '#FFFFFF',
      style: {
        fontSize: '12px',
        color: '#1D243E',
        fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
        lineHeight: '20px',
      },
      formatter() {
        const p0 = this.points[0];
        let prefixText;
        switch (option) {
          case 1:
            prefixText = dayLang + ' ';
            break;
          case 2:
            prefixText = dayForLang + ': ';
            break;
          case 3:
            prefixText = monthLang + ' ';
            break;
          case 4:
            prefixText = monthForLang + ': ';
            break;
          case 5:
            prefixText = yearLang + ' ';
            break;
          default:
            prefixText = '';
        }

        let tooltip = '<b>' + prefixText + p0.point.category + '</b>';
        for (let i = 0; i < this.points.length; i++) {
          const p = this.points[i];
          tooltip += '<br/><span style="color:' + p.point.color + '">\u25CF </span>' + '<span style="color:#6C738D">' + p.series.name + ':</span> ' + (p.series.name === 'Tin nhắn' || p.series.name === 'Chứng thực' ? p.point.y.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + ' <span style="text-decoration: underline;">đ</span>' : p.point.y.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'));
        }
        return tooltip;
      }
    };

    let maxContractChart = 0;
    let maxSmsChart = 0;
    switch (option) {
      case 1:
        maxContractChart = this.maxContractChart;
        maxSmsChart = this.maxSMSChart;
        break;
      case 2:
        maxContractChart = this.maxContractChartWeek;
        maxSmsChart = this.maxSMSChartWeek;
        break;
      case 3:
        maxContractChart = this.maxContractChartMonth;
        maxSmsChart = this.maxSMSChartMonth;
        break;
      case 4:
        maxContractChart = this.maxContractChartQuarter;
        maxSmsChart = this.maxSMSChartQuarter;
        break;
      case 5:
        maxContractChart = this.maxContractChartYear;
        maxSmsChart = this.maxSMSChartYear;
        break;
      default:
        return;
    }
    this.chartOptionsConsumption = {
      chart: {
        type: 'line',
        spacingLeft: 10,
        spacingRight: 10,
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      xAxis: [{
        categories,
        crosshair: {
          color: '#6C738D',
          width: 1,
          dashStyle: 'longdash'
        },
        labels: {
          format: '<span>{value}</span>',
          // step: step,
          style: {
            fontSize: '12px',
            fontWeight: '600',
            fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
            color: '#696F8C'
          },
        },
      }],
      yAxis: [
        { // Primary yAxis
          min: 0,
          max: maxContractChart,
          gridLineWidth: 0,
          allowDecimals: false,
          title: {
            text: ''
          },
          labels: {
            formatter() {
              return '<span>' + this.value + '</span>';
            },
            style: {
              fontSize: '12px',
              fontWeight: '600',
              opacity: '1',
              fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
              // color: Highcharts.getOptions().colors[1],
              color: '#696F8C'
            }
          },
        },
        { // Secondary yAxis
          min: 0,
          max: maxSmsChart,
          gridLineWidth: 0,
          allowDecimals: false,
          title: {
            text: ''
          },
          labels: {
            formatter() {
              return '<span>' + this.value + ' đ</span>';
            },
            style: {
              fontSize: '12px',
              fontWeight: '600',
              opacity: '1',
              fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
              // color: Highcharts.getOptions().colors[0],
              color: '#696F8C'

            }
          },
          opposite: true
        }
      ],
      tooltip: tooltips,
      series: data
    };
  }

  onBtnUploadClick() {
    this.router.navigate([this.ADD_DOCUMENT_LINK], {
      queryParams: {
        openSelected: 1
      }
    });
  }

  onSelectedFormClick() {
    this.router.navigate([this.ADD_DOCUMENT_LINK], {
      queryParams: {
        openSelected: 2
      }
    });
  }

  isExpiredDate(date: any): boolean {
    const currentTime = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const expireTime = new Date(date);
    if (currentTime >= expireTime) {
      return true;
    } else {
      return false;
    }
  }

  padTo2Digits(num): string {
    return num.toString().padStart(2, '0');
  }

  formatDate(date): string {
    const a = this.padTo2Digits(date.getDate()) + '/' + this.padTo2Digits(date.getMonth() + 1) + '/' + date.getFullYear();
    return a;
  }

  setValueStorageDigitalContract(response) {
    const value = response.data.storageDigitalContract;
    const gigabyte = 1073741824;
    const megabyte = 1048576;
    const kilobyte = 1024;
    if (value >= gigabyte) {
      this.calculateCapacity(value, gigabyte);
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '0' && this.storageDigitalContractValue.indexOf('.') > 0) {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '.') {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      this.unitStorageDigitalContract = 'GB';
    } else if (value > gigabyte / 10) {
      this.calculateCapacity(value, megabyte);
      this.storageDigitalContractValue = (Math.floor((value / gigabyte) * 1000) / 1000).toFixed(3);
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '0' && this.storageDigitalContractValue.indexOf('.') > 0) {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '.') {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      this.unitStorageDigitalContract = 'GB';
    } else if (value === megabyte) {
      this.calculateCapacity(value, megabyte);
      this.storageDigitalContractValue = '1';
      this.unitStorageDigitalContract = 'MB';
    } else if (value > megabyte / 10) {
      this.calculateCapacity(value, megabyte);
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '0' && this.storageDigitalContractValue.indexOf('.') > 0) {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '.') {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      this.unitStorageDigitalContract = 'MB';
    } else if (value === kilobyte) {
      this.calculateCapacity(value, kilobyte);
      this.storageDigitalContractValue = '1';
      this.unitStorageDigitalContract = 'KB';
    } else if (value > 0) {
      this.calculateCapacity(value, kilobyte);
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '0' && this.storageDigitalContractValue.indexOf('.') > 0) {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      while (this.storageDigitalContractValue.length > 0 && this.storageDigitalContractValue.slice(-1) === '.') {
        this.storageDigitalContractValue = this.storageDigitalContractValue.slice(0, -1);
      }
      this.unitStorageDigitalContract = 'KB';
    } else {
      this.storageDigitalContractValue = '0';
      this.enterpriseByService.storage_digital_contract = 0;
      this.unitStorageDigitalContract = 'KB';
      // this.isShowRounding = true;
    }

  }

  calculateCapacity(value, type) {
    this.enterpriseByService.storage_digital_contract = value / type;
    if (value % type === 0) {
      this.storageDigitalContractValue = (value / type).toString();
    } else {
      const phanNguyen = Math.floor(value / type);
      const phanDu = value % type;
      this.storageDigitalContractValue = phanNguyen.toString() + (Math.floor((phanDu / type) * 1000) / 1000).toFixed(3).substring(1);
    }
  }

  setValueStorageThan10Mb(response) {
    const value = response.data.biggerThan10MBFileSize;
    const gigabyte = 1073741824;
    const megabyte = 1048576;
    const kilobyte = 1024;
    if (value >= gigabyte) {
      this.calculateThan10MB(value, gigabyte);
      while (this.storageThan10MBValue.length > 0 && this.storageThan10MBValue.slice(-1) === '0' && this.storageThan10MBValue.indexOf('.') > 0) {
        this.storageThan10MBValue = this.storageThan10MBValue.slice(0, -1);
      }
      while (this.storageThan10MBValue.length > 0 && this.storageThan10MBValue.slice(-1) === '.') {
        this.storageThan10MBValue = this.storageThan10MBValue.slice(0, -1);
      }
      this.unitStorageThan10MB = 'GB';
    } else if (value > gigabyte / 10) {
      this.calculateThan10MB(value, megabyte);
      this.storageThan10MBValue = (Math.floor((value / gigabyte) * 1000) / 1000).toFixed(3);
      while (this.storageThan10MBValue.length > 0 && this.storageThan10MBValue.slice(-1) === '0' && this.storageThan10MBValue.indexOf('.') > 0) {
        this.storageThan10MBValue = this.storageThan10MBValue.slice(0, -1);
      }
      while (this.storageThan10MBValue.length > 0 && this.storageThan10MBValue.slice(-1) === '.') {
        this.storageThan10MBValue = this.storageThan10MBValue.slice(0, -1);
      }
      this.unitStorageThan10MB = 'GB';
    } else if (value === megabyte) {
      this.calculateThan10MB(value, megabyte);
      this.storageThan10MBValue = '1';
      this.unitStorageThan10MB = 'MB';
    } else if (value > megabyte / 10) {
      this.calculateThan10MB(value, megabyte);
      while (this.storageThan10MBValue.length > 0 && this.storageThan10MBValue.slice(-1) === '0' && this.storageThan10MBValue.indexOf('.') > 0) {
        this.storageThan10MBValue = this.storageThan10MBValue.slice(0, -1);
      }
      while (this.storageThan10MBValue.length > 0 && this.storageThan10MBValue.slice(-1) === '.') {
        this.storageThan10MBValue = this.storageThan10MBValue.slice(0, -1);
      }
      this.unitStorageThan10MB = 'MB';
    } else if (value === kilobyte) {
      this.calculateThan10MB(value, kilobyte);
      this.storageThan10MBValue = '1';
      this.unitStorageThan10MB = 'KB';
    } else if (value > 0) {
      this.calculateThan10MB(value, kilobyte);
      while (this.storageThan10MBValue.length > 0 && this.storageThan10MBValue.slice(-1) === '0' && this.storageThan10MBValue.indexOf('.') > 0) {
        this.storageThan10MBValue = this.storageThan10MBValue.slice(0, -1);
      }
      while (this.storageThan10MBValue.length > 0 && this.storageThan10MBValue.slice(-1) === '.') {
        this.storageThan10MBValue = this.storageThan10MBValue.slice(0, -1);
      }
      this.unitStorageThan10MB = 'KB';
    } else {
      this.storageThan10MBValue = '0';
      this.enterpriseByService.storage_than10MB = 0;
      this.unitStorageThan10MB = 'KB';
      // this.isShowRounding = true;
    }

  }

  calculateThan10MB(value, type) {
    this.enterpriseByService.storage_than10MB = value / type;
    if (value % type === 0) {
      this.storageThan10MBValue = (value / type).toString();
    } else {
      const phanNguyen = Math.floor(value / type);
      const phanDu = value % type;
      this.storageThan10MBValue = phanNguyen.toString() + (Math.floor((phanDu / type) * 1000) / 1000).toFixed(3).substring(1);
    }
  }


  getMe() {
    const dayToExpire = +localStorage.getItem('dayToExpire');
    const numberDayShowWarningPassword = localStorage.getItem('numberDayShowWarningPassword') == 'undefined' ? 10 : +localStorage.getItem('numberDayShowWarningPassword');
    this.me = {
      messagePasswordExpired: +dayToExpire < 1 ? (+dayToExpire == 0 ? this.message.getMessage('analysis.analysis_report_enterprise.notify_password_expire_today') : this.message.getMessage('messages.expired_password')) : this.commonService.format(this.message.getMessage('analysis.analysis_report_enterprise.notify_password_expire'), dayToExpire),
      isWarning: +dayToExpire <= numberDayShowWarningPassword ? true : false
    };
    if (this.me.isWarning && this.me.messagePasswordExpired == '') {
      this.me = {
        ...this.me,
        messagePasswordExpired: +dayToExpire == 0 ? 'Mật khẩu của đơn vị SẼ HẾT HẠN trong hôm nay, vui lòng thực hiện đổi mật khẩu để tiếp tục sử dụng' : `Mật khẩu của đơn vị SẼ HẾT HẠN sau ${dayToExpire} ngày, vui lòng thực hiện đổi mật khẩu để tiếp tục sử dụng`,
      };
    }
  }

  getMaxSizeSystem() {
    const id = localStorage.getItem('enterpriseId');
    this.enterpriseConfigService.getConfig(id).subscribe(res => {
      if (res && res.success) {
        this.maxSizeSystem = res.data.maxSizeSystem ? res.data.maxSizeSystem : this.size150MB;
        this.computeFileSizeMessage();
      }
    });
  }

  computeFileSizeMessage() {
    if (this.biggerThan10MBFileSize !== 0 && !this.biggerThan10MBFileSize) {
      return;
    }
    this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.biggerThan10MBFileSize >= 0 ? this.maxSizeSystem / 1024 / 1024 : this.size10MB / 1024 / 1024)));
  }

  openDialogRefuseSignDocument(NUM: any, types: any, configMoney: any) {
    this.dialogRef = this.dialog.open(ModalMoneyTransferComponent, {
      width: '625px',
      data: {
        num: NUM,
        type: types,
        configMoney,
        document: this.document,
      }
    });
    this.dialogHandleAfterClose(this.dialogRef);
  }

  dialogHandleAfterClose(dialogRef: any) {
    return dialogRef.afterClosed().subscribe((rs) => {
      console.log(rs);
      if (rs) {
        this.getDataCountNumberDocumentOfEnterpriseByService();
      }
    });
  }

  closePopover() {
    this.visible = false;
  }

  checkPermissionCreateContract() {
    if(this.commonService.checkDefaultAdmin()) {
      return true;
    }
    if(this.permissions.includes(12)) {
      return true;
    }
    return false;
  }
}
